import { j as un, a as Yn, l as En, d as Lr, p as Yr, b as Sn, i as jr, r as Dr, c as Br, k as Gn, m as Gr, f as kr, n as Vr, o as pr, q as sr, g as xr, e as $r } from "./cage-B9sdzDdT.js";
var mn = {}, Zn = {}, on = {}, Hn = {}, cr;
function Wn() {
  return cr || (cr = 1, (function(n) {
    var A = Hn && Hn.__spreadArray || function(I, P, Z) {
      if (Z || arguments.length === 2) for (var D = 0, J = P.length, Q; D < J; D++)
        (Q || !(D in P)) && (Q || (Q = Array.prototype.slice.call(P, 0, D)), Q[D] = P[D]);
      return I.concat(Q || Array.prototype.slice.call(P));
    };
    Object.defineProperty(n, "__esModule", { value: !0 }), n.flatMapReader = n.flatMapTask = n.flatMapIO = n.flatMapEither = n.flatMapOption = n.flatMapNullable = n.liftOption = n.liftNullable = n.fromReadonlyNonEmptyArray = n.has = n.emptyRecord = n.emptyReadonlyArray = n.tail = n.head = n.isNonEmpty = n.singleton = n.right = n.left = n.isRight = n.isLeft = n.some = n.none = n.isSome = n.isNone = void 0;
    var R = /* @__PURE__ */ un(), M = function(I) {
      return I._tag === "None";
    };
    n.isNone = M;
    var O = function(I) {
      return I._tag === "Some";
    };
    n.isSome = O, n.none = { _tag: "None" };
    var f = function(I) {
      return { _tag: "Some", value: I };
    };
    n.some = f;
    var g = function(I) {
      return I._tag === "Left";
    };
    n.isLeft = g;
    var h = function(I) {
      return I._tag === "Right";
    };
    n.isRight = h;
    var c = function(I) {
      return { _tag: "Left", left: I };
    };
    n.left = c;
    var u = function(I) {
      return { _tag: "Right", right: I };
    };
    n.right = u;
    var t = function(I) {
      return [I];
    };
    n.singleton = t;
    var r = function(I) {
      return I.length > 0;
    };
    n.isNonEmpty = r;
    var v = function(I) {
      return I[0];
    };
    n.head = v;
    var b = function(I) {
      return I.slice(1);
    };
    n.tail = b, n.emptyReadonlyArray = [], n.emptyRecord = {}, n.has = Object.prototype.hasOwnProperty;
    var N = function(I) {
      return A([I[0]], I.slice(1), !0);
    };
    n.fromReadonlyNonEmptyArray = N;
    var S = function(I) {
      return function(P, Z) {
        return function() {
          for (var D = [], J = 0; J < arguments.length; J++)
            D[J] = arguments[J];
          var Q = P.apply(void 0, D);
          return I.fromEither(Q == null ? (0, n.left)(Z.apply(void 0, D)) : (0, n.right)(Q));
        };
      };
    };
    n.liftNullable = S;
    var i = function(I) {
      return function(P, Z) {
        return function() {
          for (var D = [], J = 0; J < arguments.length; J++)
            D[J] = arguments[J];
          var Q = P.apply(void 0, D);
          return I.fromEither((0, n.isNone)(Q) ? (0, n.left)(Z.apply(void 0, D)) : (0, n.right)(Q.value));
        };
      };
    };
    n.liftOption = i;
    var E = function(I, P) {
      return /* @__PURE__ */ (0, R.dual)(3, function(Z, D, J) {
        return P.flatMap(Z, (0, n.liftNullable)(I)(D, J));
      });
    };
    n.flatMapNullable = E;
    var e = function(I, P) {
      return /* @__PURE__ */ (0, R.dual)(3, function(Z, D, J) {
        return P.flatMap(Z, (0, n.liftOption)(I)(D, J));
      });
    };
    n.flatMapOption = e;
    var a = function(I, P) {
      return /* @__PURE__ */ (0, R.dual)(2, function(Z, D) {
        return P.flatMap(Z, function(J) {
          return I.fromEither(D(J));
        });
      });
    };
    n.flatMapEither = a;
    var q = function(I, P) {
      return /* @__PURE__ */ (0, R.dual)(2, function(Z, D) {
        return P.flatMap(Z, function(J) {
          return I.fromIO(D(J));
        });
      });
    };
    n.flatMapIO = q;
    var T = function(I, P) {
      return /* @__PURE__ */ (0, R.dual)(2, function(Z, D) {
        return P.flatMap(Z, function(J) {
          return I.fromTask(D(J));
        });
      });
    };
    n.flatMapTask = T;
    var F = function(I, P) {
      return /* @__PURE__ */ (0, R.dual)(2, function(Z, D) {
        return P.flatMap(Z, function(J) {
          return I.fromReader(D(J));
        });
      });
    };
    n.flatMapReader = F;
  })(Hn)), Hn;
}
var lr;
function Vn() {
  if (lr) return on;
  lr = 1;
  var n = on && on.__createBinding || (Object.create ? (function(i, E, e, a) {
    a === void 0 && (a = e);
    var q = Object.getOwnPropertyDescriptor(E, e);
    (!q || ("get" in q ? !E.__esModule : q.writable || q.configurable)) && (q = { enumerable: !0, get: function() {
      return E[e];
    } }), Object.defineProperty(i, a, q);
  }) : (function(i, E, e, a) {
    a === void 0 && (a = e), i[a] = E[e];
  })), A = on && on.__setModuleDefault || (Object.create ? (function(i, E) {
    Object.defineProperty(i, "default", { enumerable: !0, value: E });
  }) : function(i, E) {
    i.default = E;
  }), R = on && on.__importStar || function(i) {
    if (i && i.__esModule) return i;
    var E = {};
    if (i != null) for (var e in i) e !== "default" && Object.prototype.hasOwnProperty.call(i, e) && n(E, i, e);
    return A(E, i), E;
  };
  Object.defineProperty(on, "__esModule", { value: !0 }), on.ap = f, on.apFirst = g, on.apSecond = h, on.apS = c, on.getApplySemigroup = u, on.sequenceT = b, on.sequenceS = S;
  var M = /* @__PURE__ */ un(), O = R(/* @__PURE__ */ Wn());
  function f(i, E) {
    return function(e) {
      return function(a) {
        return i.ap(i.map(a, function(q) {
          return function(T) {
            return E.ap(q, T);
          };
        }), e);
      };
    };
  }
  function g(i) {
    return function(E) {
      return function(e) {
        return i.ap(i.map(e, function(a) {
          return function() {
            return a;
          };
        }), E);
      };
    };
  }
  function h(i) {
    return function(E) {
      return function(e) {
        return i.ap(i.map(e, function() {
          return function(a) {
            return a;
          };
        }), E);
      };
    };
  }
  function c(i) {
    return function(E, e) {
      return function(a) {
        return i.ap(i.map(a, function(q) {
          return function(T) {
            var F;
            return Object.assign({}, q, (F = {}, F[E] = T, F));
          };
        }), e);
      };
    };
  }
  function u(i) {
    return function(E) {
      return {
        concat: function(e, a) {
          return i.ap(i.map(e, function(q) {
            return function(T) {
              return E.concat(q, T);
            };
          }), a);
        }
      };
    };
  }
  function t(i, E, e) {
    return function(a) {
      for (var q = Array(e.length + 1), T = 0; T < e.length; T++)
        q[T] = e[T];
      return q[e.length] = a, E === 0 ? i.apply(null, q) : t(i, E - 1, q);
    };
  }
  var r = {
    1: function(i) {
      return [i];
    },
    2: function(i) {
      return function(E) {
        return [i, E];
      };
    },
    3: function(i) {
      return function(E) {
        return function(e) {
          return [i, E, e];
        };
      };
    },
    4: function(i) {
      return function(E) {
        return function(e) {
          return function(a) {
            return [i, E, e, a];
          };
        };
      };
    },
    5: function(i) {
      return function(E) {
        return function(e) {
          return function(a) {
            return function(q) {
              return [i, E, e, a, q];
            };
          };
        };
      };
    }
  };
  function v(i) {
    return O.has.call(r, i) || (r[i] = t(M.tuple, i - 1, [])), r[i];
  }
  function b(i) {
    return function() {
      for (var E = [], e = 0; e < arguments.length; e++)
        E[e] = arguments[e];
      for (var a = E.length, q = v(a), T = i.map(E[0], q), F = 1; F < a; F++)
        T = i.ap(T, E[F]);
      return T;
    };
  }
  function N(i) {
    var E = i.length;
    switch (E) {
      case 1:
        return function(e) {
          var a;
          return a = {}, a[i[0]] = e, a;
        };
      case 2:
        return function(e) {
          return function(a) {
            var q;
            return q = {}, q[i[0]] = e, q[i[1]] = a, q;
          };
        };
      case 3:
        return function(e) {
          return function(a) {
            return function(q) {
              var T;
              return T = {}, T[i[0]] = e, T[i[1]] = a, T[i[2]] = q, T;
            };
          };
        };
      case 4:
        return function(e) {
          return function(a) {
            return function(q) {
              return function(T) {
                var F;
                return F = {}, F[i[0]] = e, F[i[1]] = a, F[i[2]] = q, F[i[3]] = T, F;
              };
            };
          };
        };
      case 5:
        return function(e) {
          return function(a) {
            return function(q) {
              return function(T) {
                return function(F) {
                  var I;
                  return I = {}, I[i[0]] = e, I[i[1]] = a, I[i[2]] = q, I[i[3]] = T, I[i[4]] = F, I;
                };
              };
            };
          };
        };
      default:
        return t(function() {
          for (var e = [], a = 0; a < arguments.length; a++)
            e[a] = arguments[a];
          for (var q = {}, T = 0; T < E; T++)
            q[i[T]] = e[T];
          return q;
        }, E - 1, []);
    }
  }
  function S(i) {
    return function(E) {
      for (var e = Object.keys(E), a = e.length, q = N(e), T = i.map(E[e[0]], q), F = 1; F < a; F++)
        T = i.ap(T, E[e[F]]);
      return T;
    };
  }
  return on;
}
var _n = {}, or;
function qn() {
  if (or) return _n;
  or = 1, Object.defineProperty(_n, "__esModule", { value: !0 }), _n.map = A, _n.flap = R, _n.bindTo = M, _n.let = O, _n.getFunctorComposition = f, _n.as = g, _n.asUnit = h;
  var n = /* @__PURE__ */ un();
  function A(c, u) {
    return function(t) {
      return function(r) {
        return c.map(r, function(v) {
          return u.map(v, t);
        });
      };
    };
  }
  function R(c) {
    return function(u) {
      return function(t) {
        return c.map(t, function(r) {
          return r(u);
        });
      };
    };
  }
  function M(c) {
    return function(u) {
      return function(t) {
        return c.map(t, function(r) {
          var v;
          return v = {}, v[u] = r, v;
        });
      };
    };
  }
  function O(c) {
    return function(u, t) {
      return function(r) {
        return c.map(r, function(v) {
          var b;
          return Object.assign({}, v, (b = {}, b[u] = t(v), b));
        });
      };
    };
  }
  function f(c, u) {
    var t = A(c, u);
    return {
      map: function(r, v) {
        return (0, n.pipe)(r, t(v));
      }
    };
  }
  function g(c) {
    return function(u, t) {
      return c.map(u, function() {
        return t;
      });
    };
  }
  function h(c) {
    var u = g(c);
    return function(t) {
      return u(t, void 0);
    };
  }
  return _n;
}
var vr;
function pn() {
  if (vr) return Zn;
  vr = 1, Object.defineProperty(Zn, "__esModule", { value: !0 }), Zn.getApplicativeMonoid = M, Zn.getApplicativeComposition = O;
  var n = /* @__PURE__ */ Vn(), A = /* @__PURE__ */ un(), R = /* @__PURE__ */ qn();
  function M(f) {
    var g = (0, n.getApplySemigroup)(f);
    return function(h) {
      return {
        concat: g(h).concat,
        empty: f.of(h.empty)
      };
    };
  }
  function O(f, g) {
    var h = (0, R.getFunctorComposition)(f, g).map, c = (0, n.ap)(f, g);
    return {
      map: h,
      of: function(u) {
        return f.of(g.of(u));
      },
      ap: function(u, t) {
        return (0, A.pipe)(u, c(t));
      }
    };
  }
  return Zn;
}
var kn = {}, dr;
function Dn() {
  if (dr) return kn;
  dr = 1, Object.defineProperty(kn, "__esModule", { value: !0 }), kn.chainFirst = n, kn.tap = A, kn.bind = R;
  function n(M) {
    var O = A(M);
    return function(f) {
      return function(g) {
        return O(g, f);
      };
    };
  }
  function A(M) {
    return function(O, f) {
      return M.chain(O, function(g) {
        return M.map(f(g), function() {
          return g;
        });
      });
    };
  }
  function R(M) {
    return function(O, f) {
      return function(g) {
        return M.chain(g, function(h) {
          return M.map(f(h), function(c) {
            var u;
            return Object.assign({}, h, (u = {}, u[O] = c, u));
          });
        });
      };
    };
  }
  return kn;
}
var In = {}, bn = {}, fn = {}, hr;
function er() {
  if (hr) return fn;
  hr = 1;
  var n = fn && fn.__createBinding || (Object.create ? (function(S, i, E, e) {
    e === void 0 && (e = E);
    var a = Object.getOwnPropertyDescriptor(i, E);
    (!a || ("get" in a ? !i.__esModule : a.writable || a.configurable)) && (a = { enumerable: !0, get: function() {
      return i[E];
    } }), Object.defineProperty(S, e, a);
  }) : (function(S, i, E, e) {
    e === void 0 && (e = E), S[e] = i[E];
  })), A = fn && fn.__setModuleDefault || (Object.create ? (function(S, i) {
    Object.defineProperty(S, "default", { enumerable: !0, value: i });
  }) : function(S, i) {
    S.default = i;
  }), R = fn && fn.__importStar || function(S) {
    if (S && S.__esModule) return S;
    var i = {};
    if (S != null) for (var E in S) E !== "default" && Object.prototype.hasOwnProperty.call(S, E) && n(i, S, E);
    return A(i, S), i;
  };
  Object.defineProperty(fn, "__esModule", { value: !0 }), fn.fromOption = g, fn.fromPredicate = h, fn.fromOptionK = c, fn.chainOptionK = u, fn.fromEitherK = t, fn.chainEitherK = r, fn.chainFirstEitherK = v, fn.filterOrElse = b, fn.tapEither = N;
  var M = /* @__PURE__ */ Dn(), O = /* @__PURE__ */ un(), f = R(/* @__PURE__ */ Wn());
  function g(S) {
    return function(i) {
      return function(E) {
        return S.fromEither(f.isNone(E) ? f.left(i()) : f.right(E.value));
      };
    };
  }
  function h(S) {
    return function(i, E) {
      return function(e) {
        return S.fromEither(i(e) ? f.right(e) : f.left(E(e)));
      };
    };
  }
  function c(S) {
    var i = g(S);
    return function(E) {
      var e = i(E);
      return function(a) {
        return (0, O.flow)(a, e);
      };
    };
  }
  function u(S, i) {
    var E = c(S);
    return function(e) {
      var a = E(e);
      return function(q) {
        return function(T) {
          return i.chain(T, a(q));
        };
      };
    };
  }
  function t(S) {
    return function(i) {
      return (0, O.flow)(i, S.fromEither);
    };
  }
  function r(S, i) {
    var E = t(S);
    return function(e) {
      return function(a) {
        return i.chain(a, E(e));
      };
    };
  }
  function v(S, i) {
    var E = N(S, i);
    return function(e) {
      return function(a) {
        return E(a, e);
      };
    };
  }
  function b(S, i) {
    return function(E, e) {
      return function(a) {
        return i.chain(a, function(q) {
          return S.fromEither(E(q) ? f.right(q) : f.left(e(q)));
        });
      };
    };
  }
  function N(S, i) {
    var E = t(S), e = (0, M.tap)(i);
    return function(a, q) {
      return e(a, E(q));
    };
  }
  return fn;
}
var rr = {}, mr;
function zr() {
  return mr || (mr = 1, (function(n) {
    Object.defineProperty(n, "__esModule", { value: !0 }), n.and = n.or = n.not = n.Contravariant = n.getMonoidAll = n.getSemigroupAll = n.getMonoidAny = n.getSemigroupAny = n.URI = n.contramap = void 0;
    var A = /* @__PURE__ */ un(), R = function(r, v) {
      return (0, A.pipe)(r, (0, n.contramap)(v));
    }, M = function(r) {
      return function(v) {
        return (0, A.flow)(r, v);
      };
    };
    n.contramap = M, n.URI = "Predicate";
    var O = function() {
      return {
        concat: function(r, v) {
          return (0, A.pipe)(r, (0, n.or)(v));
        }
      };
    };
    n.getSemigroupAny = O;
    var f = function() {
      return {
        concat: (0, n.getSemigroupAny)().concat,
        empty: A.constFalse
      };
    };
    n.getMonoidAny = f;
    var g = function() {
      return {
        concat: function(r, v) {
          return (0, A.pipe)(r, (0, n.and)(v));
        }
      };
    };
    n.getSemigroupAll = g;
    var h = function() {
      return {
        concat: (0, n.getSemigroupAll)().concat,
        empty: A.constTrue
      };
    };
    n.getMonoidAll = h, n.Contravariant = {
      URI: n.URI,
      contramap: R
    };
    var c = function(r) {
      return function(v) {
        return !r(v);
      };
    };
    n.not = c;
    var u = function(r) {
      return function(v) {
        return function(b) {
          return v(b) || r(b);
        };
      };
    };
    n.or = u;
    var t = function(r) {
      return function(v) {
        return function(b) {
          return v(b) && r(b);
        };
      };
    };
    n.and = t;
  })(rr)), rr;
}
var Rn = {}, gn = {}, gr;
function na() {
  if (gr) return gn;
  gr = 1, Object.defineProperty(gn, "__esModule", { value: !0 }), gn.concatAll = gn.endo = gn.filterSecond = gn.filterFirst = gn.reverse = void 0;
  var n = function(f) {
    return {
      concat: function(g, h) {
        return f.concat(h, g);
      }
    };
  };
  gn.reverse = n;
  var A = function(f) {
    return function(g) {
      return {
        concat: function(h, c) {
          return f(h) ? g.concat(h, c) : c;
        }
      };
    };
  };
  gn.filterFirst = A;
  var R = function(f) {
    return function(g) {
      return {
        concat: function(h, c) {
          return f(c) ? g.concat(h, c) : h;
        }
      };
    };
  };
  gn.filterSecond = R;
  var M = function(f) {
    return function(g) {
      return {
        concat: function(h, c) {
          return g.concat(f(h), f(c));
        }
      };
    };
  };
  gn.endo = M;
  var O = function(f) {
    return function(g) {
      return function(h) {
        return h.reduce(function(c, u) {
          return f.concat(c, u);
        }, g);
      };
    };
  };
  return gn.concatAll = O, gn;
}
var ar = {}, tr = {}, yr;
function ra() {
  return yr || (yr = 1, (function(n) {
    Object.defineProperty(n, "__esModule", { value: !0 }), n.eqDate = n.eqNumber = n.eqString = n.eqBoolean = n.eq = n.strictEqual = n.getStructEq = n.getTupleEq = n.Contravariant = n.getMonoid = n.getSemigroup = n.eqStrict = n.URI = n.contramap = n.tuple = n.struct = n.fromEquals = void 0;
    var A = /* @__PURE__ */ un(), R = function(t) {
      return {
        equals: function(r, v) {
          return r === v || t(r, v);
        }
      };
    };
    n.fromEquals = R;
    var M = function(t) {
      return (0, n.fromEquals)(function(r, v) {
        for (var b in t)
          if (!t[b].equals(r[b], v[b]))
            return !1;
        return !0;
      });
    };
    n.struct = M;
    var O = function() {
      for (var t = [], r = 0; r < arguments.length; r++)
        t[r] = arguments[r];
      return (0, n.fromEquals)(function(v, b) {
        return t.every(function(N, S) {
          return N.equals(v[S], b[S]);
        });
      });
    };
    n.tuple = O;
    var f = function(t, r) {
      return (0, A.pipe)(t, (0, n.contramap)(r));
    }, g = function(t) {
      return function(r) {
        return (0, n.fromEquals)(function(v, b) {
          return r.equals(t(v), t(b));
        });
      };
    };
    n.contramap = g, n.URI = "Eq", n.eqStrict = {
      equals: function(t, r) {
        return t === r;
      }
    };
    var h = {
      equals: function() {
        return !0;
      }
    }, c = function() {
      return {
        concat: function(t, r) {
          return (0, n.fromEquals)(function(v, b) {
            return t.equals(v, b) && r.equals(v, b);
          });
        }
      };
    };
    n.getSemigroup = c;
    var u = function() {
      return {
        concat: (0, n.getSemigroup)().concat,
        empty: h
      };
    };
    n.getMonoid = u, n.Contravariant = {
      URI: n.URI,
      contramap: f
    }, n.getTupleEq = n.tuple, n.getStructEq = n.struct, n.strictEqual = n.eqStrict.equals, n.eq = n.Contravariant, n.eqBoolean = n.eqStrict, n.eqString = n.eqStrict, n.eqNumber = n.eqStrict, n.eqDate = {
      equals: function(t, r) {
        return t.valueOf() === r.valueOf();
      }
    };
  })(tr)), tr;
}
var Ir;
function aa() {
  return Ir || (Ir = 1, (function(n) {
    Object.defineProperty(n, "__esModule", { value: !0 }), n.ordDate = n.ordNumber = n.ordString = n.ordBoolean = n.ord = n.getDualOrd = n.getTupleOrd = n.between = n.clamp = n.max = n.min = n.geq = n.leq = n.gt = n.lt = n.equals = n.trivial = n.Contravariant = n.getMonoid = n.getSemigroup = n.URI = n.contramap = n.reverse = n.tuple = n.fromCompare = n.equalsDefault = void 0;
    var A = /* @__PURE__ */ ra(), R = /* @__PURE__ */ un(), M = function(F) {
      return function(I, P) {
        return I === P || F(I, P) === 0;
      };
    };
    n.equalsDefault = M;
    var O = function(F) {
      return {
        equals: (0, n.equalsDefault)(F),
        compare: function(I, P) {
          return I === P ? 0 : F(I, P);
        }
      };
    };
    n.fromCompare = O;
    var f = function() {
      for (var F = [], I = 0; I < arguments.length; I++)
        F[I] = arguments[I];
      return (0, n.fromCompare)(function(P, Z) {
        for (var D = 0; D < F.length - 1; D++) {
          var J = F[D].compare(P[D], Z[D]);
          if (J !== 0)
            return J;
        }
        return F[D].compare(P[D], Z[D]);
      });
    };
    n.tuple = f;
    var g = function(F) {
      return (0, n.fromCompare)(function(I, P) {
        return F.compare(P, I);
      });
    };
    n.reverse = g;
    var h = function(F, I) {
      return (0, R.pipe)(F, (0, n.contramap)(I));
    }, c = function(F) {
      return function(I) {
        return (0, n.fromCompare)(function(P, Z) {
          return I.compare(F(P), F(Z));
        });
      };
    };
    n.contramap = c, n.URI = "Ord";
    var u = function() {
      return {
        concat: function(F, I) {
          return (0, n.fromCompare)(function(P, Z) {
            var D = F.compare(P, Z);
            return D !== 0 ? D : I.compare(P, Z);
          });
        }
      };
    };
    n.getSemigroup = u;
    var t = function() {
      return {
        concat: (0, n.getSemigroup)().concat,
        empty: (0, n.fromCompare)(function() {
          return 0;
        })
      };
    };
    n.getMonoid = t, n.Contravariant = {
      URI: n.URI,
      contramap: h
    }, n.trivial = {
      equals: R.constTrue,
      compare: /* @__PURE__ */ (0, R.constant)(0)
    };
    var r = function(F) {
      return function(I) {
        return function(P) {
          return P === I || F.compare(P, I) === 0;
        };
      };
    };
    n.equals = r;
    var v = function(F) {
      return function(I, P) {
        return F.compare(I, P) === -1;
      };
    };
    n.lt = v;
    var b = function(F) {
      return function(I, P) {
        return F.compare(I, P) === 1;
      };
    };
    n.gt = b;
    var N = function(F) {
      return function(I, P) {
        return F.compare(I, P) !== 1;
      };
    };
    n.leq = N;
    var S = function(F) {
      return function(I, P) {
        return F.compare(I, P) !== -1;
      };
    };
    n.geq = S;
    var i = function(F) {
      return function(I, P) {
        return I === P || F.compare(I, P) < 1 ? I : P;
      };
    };
    n.min = i;
    var E = function(F) {
      return function(I, P) {
        return I === P || F.compare(I, P) > -1 ? I : P;
      };
    };
    n.max = E;
    var e = function(F) {
      var I = (0, n.min)(F), P = (0, n.max)(F);
      return function(Z, D) {
        return function(J) {
          return P(I(J, D), Z);
        };
      };
    };
    n.clamp = e;
    var a = function(F) {
      var I = (0, n.lt)(F), P = (0, n.gt)(F);
      return function(Z, D) {
        return function(J) {
          return !(I(J, Z) || P(J, D));
        };
      };
    };
    n.between = a, n.getTupleOrd = n.tuple, n.getDualOrd = n.reverse, n.ord = n.Contravariant;
    function q(F, I) {
      return F < I ? -1 : F > I ? 1 : 0;
    }
    var T = {
      equals: A.eqStrict.equals,
      compare: q
    };
    n.ordBoolean = T, n.ordString = T, n.ordNumber = T, n.ordDate = (0, R.pipe)(
      n.ordNumber,
      /* @__PURE__ */ (0, n.contramap)(function(F) {
        return F.valueOf();
      })
    );
  })(ar)), ar;
}
var Or;
function ta() {
  return Or || (Or = 1, (function(n) {
    var A = Rn && Rn.__createBinding || (Object.create ? (function(e, a, q, T) {
      T === void 0 && (T = q);
      var F = Object.getOwnPropertyDescriptor(a, q);
      (!F || ("get" in F ? !a.__esModule : F.writable || F.configurable)) && (F = { enumerable: !0, get: function() {
        return a[q];
      } }), Object.defineProperty(e, T, F);
    }) : (function(e, a, q, T) {
      T === void 0 && (T = q), e[T] = a[q];
    })), R = Rn && Rn.__setModuleDefault || (Object.create ? (function(e, a) {
      Object.defineProperty(e, "default", { enumerable: !0, value: a });
    }) : function(e, a) {
      e.default = a;
    }), M = Rn && Rn.__importStar || function(e) {
      if (e && e.__esModule) return e;
      var a = {};
      if (e != null) for (var q in e) q !== "default" && Object.prototype.hasOwnProperty.call(e, q) && A(a, e, q);
      return R(a, e), a;
    };
    Object.defineProperty(n, "__esModule", { value: !0 }), n.semigroupProduct = n.semigroupSum = n.semigroupString = n.getFunctionSemigroup = n.semigroupAny = n.semigroupAll = n.getIntercalateSemigroup = n.getMeetSemigroup = n.getJoinSemigroup = n.getDualSemigroup = n.getStructSemigroup = n.getTupleSemigroup = n.getFirstSemigroup = n.getLastSemigroup = n.getObjectSemigroup = n.semigroupVoid = n.concatAll = n.last = n.first = n.intercalate = n.tuple = n.struct = n.reverse = n.constant = n.max = n.min = void 0, n.fold = E;
    var O = /* @__PURE__ */ un(), f = M(/* @__PURE__ */ Wn()), g = M(/* @__PURE__ */ na()), h = M(/* @__PURE__ */ aa()), c = function(e) {
      return {
        concat: h.min(e)
      };
    };
    n.min = c;
    var u = function(e) {
      return {
        concat: h.max(e)
      };
    };
    n.max = u;
    var t = function(e) {
      return {
        concat: function() {
          return e;
        }
      };
    };
    n.constant = t, n.reverse = g.reverse;
    var r = function(e) {
      return {
        concat: function(a, q) {
          var T = {};
          for (var F in e)
            f.has.call(e, F) && (T[F] = e[F].concat(a[F], q[F]));
          return T;
        }
      };
    };
    n.struct = r;
    var v = function() {
      for (var e = [], a = 0; a < arguments.length; a++)
        e[a] = arguments[a];
      return {
        concat: function(q, T) {
          return e.map(function(F, I) {
            return F.concat(q[I], T[I]);
          });
        }
      };
    };
    n.tuple = v;
    var b = function(e) {
      return function(a) {
        return {
          concat: function(q, T) {
            return a.concat(q, a.concat(e, T));
          }
        };
      };
    };
    n.intercalate = b;
    var N = function() {
      return { concat: O.identity };
    };
    n.first = N;
    var S = function() {
      return { concat: function(e, a) {
        return a;
      } };
    };
    n.last = S, n.concatAll = g.concatAll, n.semigroupVoid = (0, n.constant)(void 0);
    var i = function() {
      return {
        concat: function(e, a) {
          return Object.assign({}, e, a);
        }
      };
    };
    n.getObjectSemigroup = i, n.getLastSemigroup = n.last, n.getFirstSemigroup = n.first, n.getTupleSemigroup = n.tuple, n.getStructSemigroup = n.struct, n.getDualSemigroup = n.reverse, n.getJoinSemigroup = n.max, n.getMeetSemigroup = n.min, n.getIntercalateSemigroup = n.intercalate;
    function E(e) {
      var a = (0, n.concatAll)(e);
      return function(q, T) {
        return T === void 0 ? a(q) : a(q)(T);
      };
    }
    n.semigroupAll = {
      concat: function(e, a) {
        return e && a;
      }
    }, n.semigroupAny = {
      concat: function(e, a) {
        return e || a;
      }
    }, n.getFunctionSemigroup = O.getSemigroup, n.semigroupString = {
      concat: function(e, a) {
        return e + a;
      }
    }, n.semigroupSum = {
      concat: function(e, a) {
        return e + a;
      }
    }, n.semigroupProduct = {
      concat: function(e, a) {
        return e * a;
      }
    };
  })(Rn)), Rn;
}
var ir = {}, Er;
function sn() {
  return Er || (Er = 1, (function(n) {
    Object.defineProperty(n, "__esModule", { value: !0 }), n.right = n.left = n.flap = n.Functor = n.Bifunctor = n.URI = n.bimap = n.mapLeft = n.map = n.separated = void 0;
    var A = /* @__PURE__ */ un(), R = /* @__PURE__ */ qn(), M = function(v, b) {
      return { left: v, right: b };
    };
    n.separated = M;
    var O = function(v, b) {
      return (0, A.pipe)(v, (0, n.map)(b));
    }, f = function(v, b) {
      return (0, A.pipe)(v, (0, n.mapLeft)(b));
    }, g = function(v, b, N) {
      return (0, A.pipe)(v, (0, n.bimap)(b, N));
    }, h = function(v) {
      return function(b) {
        return (0, n.separated)((0, n.left)(b), v((0, n.right)(b)));
      };
    };
    n.map = h;
    var c = function(v) {
      return function(b) {
        return (0, n.separated)(v((0, n.left)(b)), (0, n.right)(b));
      };
    };
    n.mapLeft = c;
    var u = function(v, b) {
      return function(N) {
        return (0, n.separated)(v((0, n.left)(N)), b((0, n.right)(N)));
      };
    };
    n.bimap = u, n.URI = "Separated", n.Bifunctor = {
      URI: n.URI,
      mapLeft: f,
      bimap: g
    }, n.Functor = {
      URI: n.URI,
      map: O
    }, n.flap = (0, R.flap)(n.Functor);
    var t = function(v) {
      return v.left;
    };
    n.left = t;
    var r = function(v) {
      return v.right;
    };
    n.right = r;
  })(ir)), ir;
}
var On = {}, _r;
function Jr() {
  if (_r) return On;
  _r = 1;
  var n = On && On.__createBinding || (Object.create ? (function(h, c, u, t) {
    t === void 0 && (t = u);
    var r = Object.getOwnPropertyDescriptor(c, u);
    (!r || ("get" in r ? !c.__esModule : r.writable || r.configurable)) && (r = { enumerable: !0, get: function() {
      return c[u];
    } }), Object.defineProperty(h, t, r);
  }) : (function(h, c, u, t) {
    t === void 0 && (t = u), h[t] = c[u];
  })), A = On && On.__setModuleDefault || (Object.create ? (function(h, c) {
    Object.defineProperty(h, "default", { enumerable: !0, value: c });
  }) : function(h, c) {
    h.default = c;
  }), R = On && On.__importStar || function(h) {
    if (h && h.__esModule) return h;
    var c = {};
    if (h != null) for (var u in h) u !== "default" && Object.prototype.hasOwnProperty.call(h, u) && n(c, h, u);
    return A(c, h), c;
  };
  Object.defineProperty(On, "__esModule", { value: !0 }), On.wiltDefault = O, On.witherDefault = f, On.filterE = g;
  var M = R(/* @__PURE__ */ Wn());
  function O(h, c) {
    return function(u) {
      var t = h.traverse(u);
      return function(r, v) {
        return u.map(t(r, v), c.separate);
      };
    };
  }
  function f(h, c) {
    return function(u) {
      var t = h.traverse(u);
      return function(r, v) {
        return u.map(t(r, v), c.compact);
      };
    };
  }
  function g(h) {
    return function(c) {
      var u = h.wither(c);
      return function(t) {
        return function(r) {
          return u(r, function(v) {
            return c.map(t(v), function(b) {
              return b ? M.some(v) : M.none;
            });
          });
        };
      };
    };
  }
  return On;
}
var Xn = {}, br;
function ia() {
  if (br) return Xn;
  br = 1, Object.defineProperty(Xn, "__esModule", { value: !0 }), Xn.guard = n;
  function n(A, R) {
    return function(M) {
      return M ? R.of(void 0) : A.zero();
    };
  }
  return Xn;
}
var Rr;
function Zr() {
  return Rr || (Rr = 1, (function(n) {
    var A = bn && bn.__createBinding || (Object.create ? (function(o, m, U, s) {
      s === void 0 && (s = U);
      var tn = Object.getOwnPropertyDescriptor(m, U);
      (!tn || ("get" in tn ? !m.__esModule : tn.writable || tn.configurable)) && (tn = { enumerable: !0, get: function() {
        return m[U];
      } }), Object.defineProperty(o, s, tn);
    }) : (function(o, m, U, s) {
      s === void 0 && (s = U), o[s] = m[U];
    })), R = bn && bn.__setModuleDefault || (Object.create ? (function(o, m) {
      Object.defineProperty(o, "default", { enumerable: !0, value: m });
    }) : function(o, m) {
      o.default = m;
    }), M = bn && bn.__importStar || function(o) {
      if (o && o.__esModule) return o;
      var m = {};
      if (o != null) for (var U in o) U !== "default" && Object.prototype.hasOwnProperty.call(o, U) && A(m, o, U);
      return R(m, o), m;
    };
    Object.defineProperty(n, "__esModule", { value: !0 }), n.throwError = n.Witherable = n.wilt = n.wither = n.Traversable = n.sequence = n.traverse = n.Filterable = n.partitionMap = n.partition = n.filterMap = n.filter = n.Compactable = n.separate = n.compact = n.Extend = n.extend = n.Alternative = n.guard = n.Zero = n.zero = n.Alt = n.alt = n.altW = n.orElse = n.Foldable = n.reduceRight = n.foldMap = n.reduce = n.Monad = n.Chain = n.flatMap = n.Applicative = n.Apply = n.ap = n.Pointed = n.of = n.asUnit = n.as = n.Functor = n.map = n.getMonoid = n.getOrd = n.getEq = n.getShow = n.URI = n.getRight = n.getLeft = n.some = n.none = void 0, n.getLastMonoid = n.getFirstMonoid = n.getApplyMonoid = n.getApplySemigroup = n.option = n.mapNullable = n.chainFirst = n.chain = n.sequenceArray = n.traverseArray = n.traverseArrayWithIndex = n.traverseReadonlyArrayWithIndex = n.traverseReadonlyNonEmptyArrayWithIndex = n.ApT = n.apS = n.bind = n.let = n.bindTo = n.Do = n.exists = n.toUndefined = n.toNullable = n.chainNullableK = n.fromNullableK = n.tryCatchK = n.tryCatch = n.fromNullable = n.chainFirstEitherK = n.chainEitherK = n.fromEitherK = n.duplicate = n.tapEither = n.tap = n.flatten = n.apSecond = n.apFirst = n.flap = n.getOrElse = n.getOrElseW = n.fold = n.match = n.foldW = n.matchW = n.isNone = n.isSome = n.FromEither = n.fromEither = n.MonadThrow = void 0, n.fromPredicate = i, n.elem = Fn, n.getRefinement = y;
    var O = /* @__PURE__ */ pn(), f = /* @__PURE__ */ Vn(), g = M(/* @__PURE__ */ Dn()), h = /* @__PURE__ */ er(), c = /* @__PURE__ */ un(), u = /* @__PURE__ */ qn(), t = M(/* @__PURE__ */ Wn()), r = /* @__PURE__ */ zr(), v = /* @__PURE__ */ ta(), b = /* @__PURE__ */ sn(), N = /* @__PURE__ */ Jr(), S = /* @__PURE__ */ ia();
    n.none = t.none, n.some = t.some;
    function i(o) {
      return function(m) {
        return o(m) ? (0, n.some)(m) : n.none;
      };
    }
    var E = function(o) {
      return o._tag === "Right" ? n.none : (0, n.some)(o.left);
    };
    n.getLeft = E;
    var e = function(o) {
      return o._tag === "Left" ? n.none : (0, n.some)(o.right);
    };
    n.getRight = e;
    var a = function(o, m) {
      return (0, c.pipe)(o, (0, n.map)(m));
    }, q = function(o, m) {
      return (0, c.pipe)(o, (0, n.ap)(m));
    }, T = function(o, m, U) {
      return (0, c.pipe)(o, (0, n.reduce)(m, U));
    }, F = function(o) {
      var m = (0, n.foldMap)(o);
      return function(U, s) {
        return (0, c.pipe)(U, m(s));
      };
    }, I = function(o, m, U) {
      return (0, c.pipe)(o, (0, n.reduceRight)(m, U));
    }, P = function(o) {
      var m = (0, n.traverse)(o);
      return function(U, s) {
        return (0, c.pipe)(U, m(s));
      };
    }, Z = function(o, m) {
      return (0, c.pipe)(o, (0, n.alt)(m));
    }, D = function(o, m) {
      return (0, c.pipe)(o, (0, n.filter)(m));
    }, J = function(o, m) {
      return (0, c.pipe)(o, (0, n.filterMap)(m));
    }, Q = function(o, m) {
      return (0, c.pipe)(o, (0, n.extend)(m));
    }, en = function(o, m) {
      return (0, c.pipe)(o, (0, n.partition)(m));
    }, L = function(o, m) {
      return (0, c.pipe)(o, (0, n.partitionMap)(m));
    };
    n.URI = "Option";
    var k = function(o) {
      return {
        show: function(m) {
          return (0, n.isNone)(m) ? "none" : "some(".concat(o.show(m.value), ")");
        }
      };
    };
    n.getShow = k;
    var H = function(o) {
      return {
        equals: function(m, U) {
          return m === U || ((0, n.isNone)(m) ? (0, n.isNone)(U) : (0, n.isNone)(U) ? !1 : o.equals(m.value, U.value));
        }
      };
    };
    n.getEq = H;
    var rn = function(o) {
      return {
        equals: (0, n.getEq)(o).equals,
        compare: function(m, U) {
          return m === U ? 0 : (0, n.isSome)(m) ? (0, n.isSome)(U) ? o.compare(m.value, U.value) : 1 : (0, n.isSome)(U) ? -1 : 0;
        }
      };
    };
    n.getOrd = rn;
    var _ = function(o) {
      return {
        concat: function(m, U) {
          return (0, n.isNone)(m) ? U : (0, n.isNone)(U) ? m : (0, n.some)(o.concat(m.value, U.value));
        },
        empty: n.none
      };
    };
    n.getMonoid = _;
    var C = function(o) {
      return function(m) {
        return (0, n.isNone)(m) ? n.none : (0, n.some)(o(m.value));
      };
    };
    n.map = C, n.Functor = {
      URI: n.URI,
      map: a
    }, n.as = (0, c.dual)(2, (0, u.as)(n.Functor)), n.asUnit = (0, u.asUnit)(n.Functor), n.of = n.some, n.Pointed = {
      URI: n.URI,
      of: n.of
    };
    var j = function(o) {
      return function(m) {
        return (0, n.isNone)(m) || (0, n.isNone)(o) ? n.none : (0, n.some)(m.value(o.value));
      };
    };
    n.ap = j, n.Apply = {
      URI: n.URI,
      map: a,
      ap: q
    }, n.Applicative = {
      URI: n.URI,
      map: a,
      ap: q,
      of: n.of
    }, n.flatMap = (0, c.dual)(2, function(o, m) {
      return (0, n.isNone)(o) ? n.none : m(o.value);
    }), n.Chain = {
      URI: n.URI,
      map: a,
      ap: q,
      chain: n.flatMap
    }, n.Monad = {
      URI: n.URI,
      map: a,
      ap: q,
      of: n.of,
      chain: n.flatMap
    };
    var B = function(o, m) {
      return function(U) {
        return (0, n.isNone)(U) ? o : m(o, U.value);
      };
    };
    n.reduce = B;
    var x = function(o) {
      return function(m) {
        return function(U) {
          return (0, n.isNone)(U) ? o.empty : m(U.value);
        };
      };
    };
    n.foldMap = x;
    var hn = function(o, m) {
      return function(U) {
        return (0, n.isNone)(U) ? o : m(U.value, o);
      };
    };
    n.reduceRight = hn, n.Foldable = {
      URI: n.URI,
      reduce: T,
      foldMap: F,
      reduceRight: I
    }, n.orElse = (0, c.dual)(2, function(o, m) {
      return (0, n.isNone)(o) ? m() : o;
    }), n.altW = n.orElse, n.alt = n.orElse, n.Alt = {
      URI: n.URI,
      map: a,
      alt: Z
    };
    var Tn = function() {
      return n.none;
    };
    n.zero = Tn, n.Zero = {
      URI: n.URI,
      zero: n.zero
    }, n.guard = (0, S.guard)(n.Zero, n.Pointed), n.Alternative = {
      URI: n.URI,
      map: a,
      ap: q,
      of: n.of,
      alt: Z,
      zero: n.zero
    };
    var wn = function(o) {
      return function(m) {
        return (0, n.isNone)(m) ? n.none : (0, n.some)(o(m));
      };
    };
    n.extend = wn, n.Extend = {
      URI: n.URI,
      map: a,
      extend: Q
    }, n.compact = (0, n.flatMap)(c.identity);
    var Nn = /* @__PURE__ */ (0, b.separated)(n.none, n.none), Pn = function(o) {
      return (0, n.isNone)(o) ? Nn : (0, b.separated)((0, n.getLeft)(o.value), (0, n.getRight)(o.value));
    };
    n.separate = Pn, n.Compactable = {
      URI: n.URI,
      compact: n.compact,
      separate: n.separate
    };
    var $ = function(o) {
      return function(m) {
        return (0, n.isNone)(m) ? n.none : o(m.value) ? m : n.none;
      };
    };
    n.filter = $;
    var nn = function(o) {
      return function(m) {
        return (0, n.isNone)(m) ? n.none : o(m.value);
      };
    };
    n.filterMap = nn;
    var yn = function(o) {
      return function(m) {
        return (0, b.separated)(D(m, (0, r.not)(o)), D(m, o));
      };
    };
    n.partition = yn;
    var Bn = function(o) {
      return (0, c.flow)((0, n.map)(o), n.separate);
    };
    n.partitionMap = Bn, n.Filterable = {
      URI: n.URI,
      map: a,
      compact: n.compact,
      separate: n.separate,
      filter: D,
      filterMap: J,
      partition: en,
      partitionMap: L
    };
    var zn = function(o) {
      return function(m) {
        return function(U) {
          return (0, n.isNone)(U) ? o.of(n.none) : o.map(m(U.value), n.some);
        };
      };
    };
    n.traverse = zn;
    var Jn = function(o) {
      return function(m) {
        return (0, n.isNone)(m) ? o.of(n.none) : o.map(m.value, n.some);
      };
    };
    n.sequence = Jn, n.Traversable = {
      URI: n.URI,
      map: a,
      reduce: T,
      foldMap: F,
      reduceRight: I,
      traverse: P,
      sequence: n.sequence
    };
    var Kn = /* @__PURE__ */ (0, N.witherDefault)(n.Traversable, n.Compactable), Cn = /* @__PURE__ */ (0, N.wiltDefault)(n.Traversable, n.Compactable), W = function(o) {
      var m = Kn(o);
      return function(U) {
        return function(s) {
          return m(s, U);
        };
      };
    };
    n.wither = W;
    var K = function(o) {
      var m = Cn(o);
      return function(U) {
        return function(s) {
          return m(s, U);
        };
      };
    };
    n.wilt = K, n.Witherable = {
      URI: n.URI,
      map: a,
      reduce: T,
      foldMap: F,
      reduceRight: I,
      traverse: P,
      sequence: n.sequence,
      compact: n.compact,
      separate: n.separate,
      filter: D,
      filterMap: J,
      partition: en,
      partitionMap: L,
      wither: Kn,
      wilt: Cn
    };
    var w = function() {
      return n.none;
    };
    n.throwError = w, n.MonadThrow = {
      URI: n.URI,
      map: a,
      ap: q,
      of: n.of,
      chain: n.flatMap,
      throwError: n.throwError
    }, n.fromEither = n.getRight, n.FromEither = {
      URI: n.URI,
      fromEither: n.fromEither
    }, n.isSome = t.isSome;
    var V = function(o) {
      return o._tag === "None";
    };
    n.isNone = V;
    var Y = function(o, m) {
      return function(U) {
        return (0, n.isNone)(U) ? o() : m(U.value);
      };
    };
    n.matchW = Y, n.foldW = n.matchW, n.match = n.matchW, n.fold = n.match;
    var z = function(o) {
      return function(m) {
        return (0, n.isNone)(m) ? o() : m.value;
      };
    };
    n.getOrElseW = z, n.getOrElse = n.getOrElseW, n.flap = (0, u.flap)(n.Functor), n.apFirst = (0, f.apFirst)(n.Apply), n.apSecond = (0, f.apSecond)(n.Apply), n.flatten = n.compact, n.tap = (0, c.dual)(2, g.tap(n.Chain)), n.tapEither = (0, c.dual)(2, (0, h.tapEither)(n.FromEither, n.Chain)), n.duplicate = (0, n.extend)(c.identity), n.fromEitherK = (0, h.fromEitherK)(n.FromEither), n.chainEitherK = /* @__PURE__ */ (0, h.chainEitherK)(n.FromEither, n.Chain), n.chainFirstEitherK = n.tapEither;
    var an = function(o) {
      return o == null ? n.none : (0, n.some)(o);
    };
    n.fromNullable = an;
    var cn = function(o) {
      try {
        return (0, n.some)(o());
      } catch {
        return n.none;
      }
    };
    n.tryCatch = cn;
    var vn = function(o) {
      return function() {
        for (var m = [], U = 0; U < arguments.length; U++)
          m[U] = arguments[U];
        return (0, n.tryCatch)(function() {
          return o.apply(void 0, m);
        });
      };
    };
    n.tryCatchK = vn;
    var X = function(o) {
      return (0, c.flow)(o, n.fromNullable);
    };
    n.fromNullableK = X;
    var dn = function(o) {
      return function(m) {
        return (0, n.isNone)(m) ? n.none : (0, n.fromNullable)(o(m.value));
      };
    };
    n.chainNullableK = dn, n.toNullable = (0, n.match)(c.constNull, c.identity), n.toUndefined = (0, n.match)(c.constUndefined, c.identity);
    function Fn(o) {
      return function(m, U) {
        if (U === void 0) {
          var s = Fn(o);
          return function(tn) {
            return s(m, tn);
          };
        }
        return (0, n.isNone)(U) ? !1 : o.equals(m, U.value);
      };
    }
    var xn = function(o) {
      return function(m) {
        return (0, n.isNone)(m) ? !1 : o(m.value);
      };
    };
    n.exists = xn, n.Do = (0, n.of)(t.emptyRecord), n.bindTo = (0, u.bindTo)(n.Functor);
    var $n = /* @__PURE__ */ (0, u.let)(n.Functor);
    n.let = $n, n.bind = g.bind(n.Chain), n.apS = (0, f.apS)(n.Apply), n.ApT = (0, n.of)(t.emptyReadonlyArray);
    var nr = function(o) {
      return function(m) {
        var U = o(0, t.head(m));
        if ((0, n.isNone)(U))
          return n.none;
        for (var s = [U.value], tn = 1; tn < m.length; tn++) {
          var fr = o(tn, m[tn]);
          if ((0, n.isNone)(fr))
            return n.none;
          s.push(fr.value);
        }
        return (0, n.some)(s);
      };
    };
    n.traverseReadonlyNonEmptyArrayWithIndex = nr;
    var d = function(o) {
      var m = (0, n.traverseReadonlyNonEmptyArrayWithIndex)(o);
      return function(U) {
        return t.isNonEmpty(U) ? m(U) : n.ApT;
      };
    };
    n.traverseReadonlyArrayWithIndex = d, n.traverseArrayWithIndex = n.traverseReadonlyArrayWithIndex;
    var l = function(o) {
      return (0, n.traverseReadonlyArrayWithIndex)(function(m, U) {
        return o(U);
      });
    };
    n.traverseArray = l, n.sequenceArray = /* @__PURE__ */ (0, n.traverseArray)(c.identity), n.chain = n.flatMap, n.chainFirst = n.tap;
    function y(o) {
      return function(m) {
        return (0, n.isSome)(o(m));
      };
    }
    n.mapNullable = n.chainNullableK, n.option = {
      URI: n.URI,
      map: a,
      of: n.of,
      ap: q,
      chain: n.flatMap,
      reduce: T,
      foldMap: F,
      reduceRight: I,
      traverse: P,
      sequence: n.sequence,
      zero: n.zero,
      alt: Z,
      extend: Q,
      compact: n.compact,
      separate: n.separate,
      filter: D,
      filterMap: J,
      partition: en,
      partitionMap: L,
      wither: Kn,
      wilt: Cn,
      throwError: n.throwError
    }, n.getApplySemigroup = (0, f.getApplySemigroup)(n.Apply), n.getApplyMonoid = (0, O.getApplicativeMonoid)(n.Applicative);
    var p = function() {
      return (0, n.getMonoid)((0, v.first)());
    };
    n.getFirstMonoid = p;
    var ln = function() {
      return (0, n.getMonoid)((0, v.last)());
    };
    n.getLastMonoid = ln;
  })(bn)), bn;
}
var Mr;
function Hr() {
  if (Mr) return In;
  Mr = 1;
  var n = In && In.__createBinding || (Object.create ? (function(t, r, v, b) {
    b === void 0 && (b = v);
    var N = Object.getOwnPropertyDescriptor(r, v);
    (!N || ("get" in N ? !r.__esModule : N.writable || N.configurable)) && (N = { enumerable: !0, get: function() {
      return r[v];
    } }), Object.defineProperty(t, b, N);
  }) : (function(t, r, v, b) {
    b === void 0 && (b = v), t[b] = r[v];
  })), A = In && In.__setModuleDefault || (Object.create ? (function(t, r) {
    Object.defineProperty(t, "default", { enumerable: !0, value: r });
  }) : function(t, r) {
    t.default = r;
  }), R = In && In.__importStar || function(t) {
    if (t && t.__esModule) return t;
    var r = {};
    if (t != null) for (var v in t) v !== "default" && Object.prototype.hasOwnProperty.call(t, v) && n(r, t, v);
    return A(r, t), r;
  };
  Object.defineProperty(In, "__esModule", { value: !0 }), In.compact = h, In.separate = c, In.getCompactableComposition = u;
  var M = /* @__PURE__ */ un(), O = /* @__PURE__ */ qn(), f = /* @__PURE__ */ Zr(), g = R(/* @__PURE__ */ sn());
  function h(t, r) {
    return function(v) {
      return t.map(v, r.compact);
    };
  }
  function c(t, r, v) {
    var b = h(t, r), N = (0, O.map)(t, v);
    return function(S) {
      return g.separated(b((0, M.pipe)(S, N(f.getLeft))), b((0, M.pipe)(S, N(f.getRight))));
    };
  }
  function u(t, r) {
    var v = (0, O.getFunctorComposition)(t, r).map;
    return {
      map: v,
      compact: h(t, r),
      separate: c(t, r, r)
    };
  }
  return In;
}
var Mn = {}, Qn = {}, Ar;
function ea() {
  if (Ar) return Qn;
  Ar = 1, Object.defineProperty(Qn, "__esModule", { value: !0 }), Qn.tailRec = void 0;
  var n = function(A, R) {
    for (var M = R(A); M._tag === "Left"; )
      M = R(M.left);
    return M.right;
  };
  return Qn.tailRec = n, Qn;
}
var Sr;
function Qr() {
  return Sr || (Sr = 1, (function(n) {
    var A = Mn && Mn.__createBinding || (Object.create ? (function(d, l, y, p) {
      p === void 0 && (p = y);
      var ln = Object.getOwnPropertyDescriptor(l, y);
      (!ln || ("get" in ln ? !l.__esModule : ln.writable || ln.configurable)) && (ln = { enumerable: !0, get: function() {
        return l[y];
      } }), Object.defineProperty(d, p, ln);
    }) : (function(d, l, y, p) {
      p === void 0 && (p = y), d[p] = l[y];
    })), R = Mn && Mn.__setModuleDefault || (Object.create ? (function(d, l) {
      Object.defineProperty(d, "default", { enumerable: !0, value: l });
    }) : function(d, l) {
      d.default = l;
    }), M = Mn && Mn.__importStar || function(d) {
      if (d && d.__esModule) return d;
      var l = {};
      if (d != null) for (var y in d) y !== "default" && Object.prototype.hasOwnProperty.call(d, y) && A(l, d, y);
      return R(l, d), l;
    };
    Object.defineProperty(n, "__esModule", { value: !0 }), n.match = n.foldW = n.matchW = n.isRight = n.isLeft = n.fromOption = n.fromPredicate = n.FromEither = n.MonadThrow = n.throwError = n.ChainRec = n.Extend = n.extend = n.Alt = n.alt = n.altW = n.Bifunctor = n.mapLeft = n.bimap = n.Traversable = n.sequence = n.traverse = n.Foldable = n.reduceRight = n.foldMap = n.reduce = n.Monad = n.Chain = n.Applicative = n.Apply = n.ap = n.apW = n.Pointed = n.of = n.asUnit = n.as = n.Functor = n.map = n.getAltValidation = n.getApplicativeValidation = n.getWitherable = n.getFilterable = n.getCompactable = n.getSemigroup = n.getEq = n.getShow = n.URI = n.flatMap = n.right = n.left = void 0, n.either = n.stringifyJSON = n.chainFirstW = n.chainFirst = n.chain = n.chainW = n.sequenceArray = n.traverseArray = n.traverseArrayWithIndex = n.traverseReadonlyArrayWithIndex = n.traverseReadonlyNonEmptyArrayWithIndex = n.ApT = n.apSW = n.apS = n.bindW = n.bind = n.let = n.bindTo = n.Do = n.exists = n.toUnion = n.chainNullableK = n.fromNullableK = n.tryCatchK = n.tryCatch = n.fromNullable = n.orElse = n.orElseW = n.swap = n.filterOrElseW = n.filterOrElse = n.flatMapOption = n.flatMapNullable = n.liftOption = n.liftNullable = n.chainOptionKW = n.chainOptionK = n.fromOptionK = n.duplicate = n.flatten = n.flattenW = n.tap = n.apSecondW = n.apSecond = n.apFirstW = n.apFirst = n.flap = n.getOrElse = n.getOrElseW = n.fold = void 0, n.getValidationMonoid = n.getValidationSemigroup = n.getApplyMonoid = n.getApplySemigroup = void 0, n.toError = V, n.elem = Y, n.parseJSON = dn, n.getValidation = nr;
    var O = /* @__PURE__ */ pn(), f = /* @__PURE__ */ Vn(), g = M(/* @__PURE__ */ Dn()), h = /* @__PURE__ */ ea(), c = /* @__PURE__ */ er(), u = /* @__PURE__ */ un(), t = /* @__PURE__ */ qn(), r = M(/* @__PURE__ */ Wn()), v = /* @__PURE__ */ sn(), b = /* @__PURE__ */ Jr();
    n.left = r.left, n.right = r.right, n.flatMap = (0, u.dual)(2, function(d, l) {
      return (0, n.isLeft)(d) ? d : l(d.right);
    });
    var N = function(d, l) {
      return (0, u.pipe)(d, (0, n.map)(l));
    }, S = function(d, l) {
      return (0, u.pipe)(d, (0, n.ap)(l));
    }, i = function(d, l, y) {
      return (0, u.pipe)(d, (0, n.reduce)(l, y));
    }, E = function(d) {
      return function(l, y) {
        var p = (0, n.foldMap)(d);
        return (0, u.pipe)(l, p(y));
      };
    }, e = function(d, l, y) {
      return (0, u.pipe)(d, (0, n.reduceRight)(l, y));
    }, a = function(d) {
      var l = (0, n.traverse)(d);
      return function(y, p) {
        return (0, u.pipe)(y, l(p));
      };
    }, q = function(d, l, y) {
      return (0, u.pipe)(d, (0, n.bimap)(l, y));
    }, T = function(d, l) {
      return (0, u.pipe)(d, (0, n.mapLeft)(l));
    }, F = function(d, l) {
      return (0, u.pipe)(d, (0, n.alt)(l));
    }, I = function(d, l) {
      return (0, u.pipe)(d, (0, n.extend)(l));
    }, P = function(d, l) {
      return (0, h.tailRec)(l(d), function(y) {
        return (0, n.isLeft)(y) ? (0, n.right)((0, n.left)(y.left)) : (0, n.isLeft)(y.right) ? (0, n.left)(l(y.right.left)) : (0, n.right)((0, n.right)(y.right.right));
      });
    };
    n.URI = "Either";
    var Z = function(d, l) {
      return {
        show: function(y) {
          return (0, n.isLeft)(y) ? "left(".concat(d.show(y.left), ")") : "right(".concat(l.show(y.right), ")");
        }
      };
    };
    n.getShow = Z;
    var D = function(d, l) {
      return {
        equals: function(y, p) {
          return y === p || ((0, n.isLeft)(y) ? (0, n.isLeft)(p) && d.equals(y.left, p.left) : (0, n.isRight)(p) && l.equals(y.right, p.right));
        }
      };
    };
    n.getEq = D;
    var J = function(d) {
      return {
        concat: function(l, y) {
          return (0, n.isLeft)(y) ? l : (0, n.isLeft)(l) ? y : (0, n.right)(d.concat(l.right, y.right));
        }
      };
    };
    n.getSemigroup = J;
    var Q = function(d) {
      var l = (0, n.left)(d.empty);
      return {
        URI: n.URI,
        _E: void 0,
        compact: function(y) {
          return (0, n.isLeft)(y) ? y : y.right._tag === "None" ? l : (0, n.right)(y.right.value);
        },
        separate: function(y) {
          return (0, n.isLeft)(y) ? (0, v.separated)(y, y) : (0, n.isLeft)(y.right) ? (0, v.separated)((0, n.right)(y.right.left), l) : (0, v.separated)(l, (0, n.right)(y.right.right));
        }
      };
    };
    n.getCompactable = Q;
    var en = function(d) {
      var l = (0, n.left)(d.empty), y = (0, n.getCompactable)(d), p = y.compact, ln = y.separate, o = function(U, s) {
        return (0, n.isLeft)(U) || s(U.right) ? U : l;
      }, m = function(U, s) {
        return (0, n.isLeft)(U) ? (0, v.separated)(U, U) : s(U.right) ? (0, v.separated)(l, (0, n.right)(U.right)) : (0, v.separated)((0, n.right)(U.right), l);
      };
      return {
        URI: n.URI,
        _E: void 0,
        map: N,
        compact: p,
        separate: ln,
        filter: o,
        filterMap: function(U, s) {
          if ((0, n.isLeft)(U))
            return U;
          var tn = s(U.right);
          return tn._tag === "None" ? l : (0, n.right)(tn.value);
        },
        partition: m,
        partitionMap: function(U, s) {
          if ((0, n.isLeft)(U))
            return (0, v.separated)(U, U);
          var tn = s(U.right);
          return (0, n.isLeft)(tn) ? (0, v.separated)((0, n.right)(tn.left), l) : (0, v.separated)(l, (0, n.right)(tn.right));
        }
      };
    };
    n.getFilterable = en;
    var L = function(d) {
      var l = (0, n.getFilterable)(d), y = (0, n.getCompactable)(d);
      return {
        URI: n.URI,
        _E: void 0,
        map: N,
        compact: l.compact,
        separate: l.separate,
        filter: l.filter,
        filterMap: l.filterMap,
        partition: l.partition,
        partitionMap: l.partitionMap,
        traverse: a,
        sequence: n.sequence,
        reduce: i,
        foldMap: E,
        reduceRight: e,
        wither: (0, b.witherDefault)(n.Traversable, y),
        wilt: (0, b.wiltDefault)(n.Traversable, y)
      };
    };
    n.getWitherable = L;
    var k = function(d) {
      return {
        URI: n.URI,
        _E: void 0,
        map: N,
        ap: function(l, y) {
          return (0, n.isLeft)(l) ? (0, n.isLeft)(y) ? (0, n.left)(d.concat(l.left, y.left)) : l : (0, n.isLeft)(y) ? y : (0, n.right)(l.right(y.right));
        },
        of: n.of
      };
    };
    n.getApplicativeValidation = k;
    var H = function(d) {
      return {
        URI: n.URI,
        _E: void 0,
        map: N,
        alt: function(l, y) {
          if ((0, n.isRight)(l))
            return l;
          var p = y();
          return (0, n.isLeft)(p) ? (0, n.left)(d.concat(l.left, p.left)) : p;
        }
      };
    };
    n.getAltValidation = H;
    var rn = function(d) {
      return function(l) {
        return (0, n.isLeft)(l) ? l : (0, n.right)(d(l.right));
      };
    };
    n.map = rn, n.Functor = {
      URI: n.URI,
      map: N
    }, n.as = (0, u.dual)(2, (0, t.as)(n.Functor)), n.asUnit = (0, t.asUnit)(n.Functor), n.of = n.right, n.Pointed = {
      URI: n.URI,
      of: n.of
    };
    var _ = function(d) {
      return function(l) {
        return (0, n.isLeft)(l) ? l : (0, n.isLeft)(d) ? d : (0, n.right)(l.right(d.right));
      };
    };
    n.apW = _, n.ap = n.apW, n.Apply = {
      URI: n.URI,
      map: N,
      ap: S
    }, n.Applicative = {
      URI: n.URI,
      map: N,
      ap: S,
      of: n.of
    }, n.Chain = {
      URI: n.URI,
      map: N,
      ap: S,
      chain: n.flatMap
    }, n.Monad = {
      URI: n.URI,
      map: N,
      ap: S,
      of: n.of,
      chain: n.flatMap
    };
    var C = function(d, l) {
      return function(y) {
        return (0, n.isLeft)(y) ? d : l(d, y.right);
      };
    };
    n.reduce = C;
    var j = function(d) {
      return function(l) {
        return function(y) {
          return (0, n.isLeft)(y) ? d.empty : l(y.right);
        };
      };
    };
    n.foldMap = j;
    var B = function(d, l) {
      return function(y) {
        return (0, n.isLeft)(y) ? d : l(y.right, d);
      };
    };
    n.reduceRight = B, n.Foldable = {
      URI: n.URI,
      reduce: i,
      foldMap: E,
      reduceRight: e
    };
    var x = function(d) {
      return function(l) {
        return function(y) {
          return (0, n.isLeft)(y) ? d.of((0, n.left)(y.left)) : d.map(l(y.right), n.right);
        };
      };
    };
    n.traverse = x;
    var hn = function(d) {
      return function(l) {
        return (0, n.isLeft)(l) ? d.of((0, n.left)(l.left)) : d.map(l.right, n.right);
      };
    };
    n.sequence = hn, n.Traversable = {
      URI: n.URI,
      map: N,
      reduce: i,
      foldMap: E,
      reduceRight: e,
      traverse: a,
      sequence: n.sequence
    };
    var Tn = function(d, l) {
      return function(y) {
        return (0, n.isLeft)(y) ? (0, n.left)(d(y.left)) : (0, n.right)(l(y.right));
      };
    };
    n.bimap = Tn;
    var wn = function(d) {
      return function(l) {
        return (0, n.isLeft)(l) ? (0, n.left)(d(l.left)) : l;
      };
    };
    n.mapLeft = wn, n.Bifunctor = {
      URI: n.URI,
      bimap: q,
      mapLeft: T
    };
    var Nn = function(d) {
      return function(l) {
        return (0, n.isLeft)(l) ? d() : l;
      };
    };
    n.altW = Nn, n.alt = n.altW, n.Alt = {
      URI: n.URI,
      map: N,
      alt: F
    };
    var Pn = function(d) {
      return function(l) {
        return (0, n.isLeft)(l) ? l : (0, n.right)(d(l));
      };
    };
    n.extend = Pn, n.Extend = {
      URI: n.URI,
      map: N,
      extend: I
    }, n.ChainRec = {
      URI: n.URI,
      map: N,
      ap: S,
      chain: n.flatMap,
      chainRec: P
    }, n.throwError = n.left, n.MonadThrow = {
      URI: n.URI,
      map: N,
      ap: S,
      of: n.of,
      chain: n.flatMap,
      throwError: n.throwError
    }, n.FromEither = {
      URI: n.URI,
      fromEither: u.identity
    }, n.fromPredicate = (0, c.fromPredicate)(n.FromEither), n.fromOption = /* @__PURE__ */ (0, c.fromOption)(n.FromEither), n.isLeft = r.isLeft, n.isRight = r.isRight;
    var $ = function(d, l) {
      return function(y) {
        return (0, n.isLeft)(y) ? d(y.left) : l(y.right);
      };
    };
    n.matchW = $, n.foldW = n.matchW, n.match = n.matchW, n.fold = n.match;
    var nn = function(d) {
      return function(l) {
        return (0, n.isLeft)(l) ? d(l.left) : l.right;
      };
    };
    n.getOrElseW = nn, n.getOrElse = n.getOrElseW, n.flap = (0, t.flap)(n.Functor), n.apFirst = (0, f.apFirst)(n.Apply), n.apFirstW = n.apFirst, n.apSecond = (0, f.apSecond)(n.Apply), n.apSecondW = n.apSecond, n.tap = (0, u.dual)(2, g.tap(n.Chain)), n.flattenW = /* @__PURE__ */ (0, n.flatMap)(u.identity), n.flatten = n.flattenW, n.duplicate = (0, n.extend)(u.identity), n.fromOptionK = /* @__PURE__ */ (0, c.fromOptionK)(n.FromEither), n.chainOptionK = (0, c.chainOptionK)(n.FromEither, n.Chain), n.chainOptionKW = n.chainOptionK;
    var yn = {
      fromEither: n.FromEither.fromEither
    };
    n.liftNullable = r.liftNullable(yn), n.liftOption = r.liftOption(yn);
    var Bn = {
      flatMap: n.flatMap
    };
    n.flatMapNullable = r.flatMapNullable(yn, Bn), n.flatMapOption = r.flatMapOption(yn, Bn), n.filterOrElse = (0, c.filterOrElse)(n.FromEither, n.Chain), n.filterOrElseW = n.filterOrElse;
    var zn = function(d) {
      return (0, n.isLeft)(d) ? (0, n.right)(d.left) : (0, n.left)(d.right);
    };
    n.swap = zn;
    var Jn = function(d) {
      return function(l) {
        return (0, n.isLeft)(l) ? d(l.left) : l;
      };
    };
    n.orElseW = Jn, n.orElse = n.orElseW;
    var Kn = function(d) {
      return function(l) {
        return l == null ? (0, n.left)(d) : (0, n.right)(l);
      };
    };
    n.fromNullable = Kn;
    var Cn = function(d, l) {
      try {
        return (0, n.right)(d());
      } catch (y) {
        return (0, n.left)(l(y));
      }
    };
    n.tryCatch = Cn;
    var W = function(d, l) {
      return function() {
        for (var y = [], p = 0; p < arguments.length; p++)
          y[p] = arguments[p];
        return (0, n.tryCatch)(function() {
          return d.apply(void 0, y);
        }, l);
      };
    };
    n.tryCatchK = W;
    var K = function(d) {
      var l = (0, n.fromNullable)(d);
      return function(y) {
        return (0, u.flow)(y, l);
      };
    };
    n.fromNullableK = K;
    var w = function(d) {
      var l = (0, n.fromNullableK)(d);
      return function(y) {
        return (0, n.flatMap)(l(y));
      };
    };
    n.chainNullableK = w, n.toUnion = (0, n.foldW)(u.identity, u.identity);
    function V(d) {
      try {
        return d instanceof Error ? d : new Error(String(d));
      } catch {
        return new Error();
      }
    }
    function Y(d) {
      return function(l, y) {
        if (y === void 0) {
          var p = Y(d);
          return function(ln) {
            return p(l, ln);
          };
        }
        return (0, n.isLeft)(y) ? !1 : d.equals(l, y.right);
      };
    }
    var z = function(d) {
      return function(l) {
        return (0, n.isLeft)(l) ? !1 : d(l.right);
      };
    };
    n.exists = z, n.Do = (0, n.of)(r.emptyRecord), n.bindTo = (0, t.bindTo)(n.Functor);
    var an = /* @__PURE__ */ (0, t.let)(n.Functor);
    n.let = an, n.bind = g.bind(n.Chain), n.bindW = n.bind, n.apS = (0, f.apS)(n.Apply), n.apSW = n.apS, n.ApT = (0, n.of)(r.emptyReadonlyArray);
    var cn = function(d) {
      return function(l) {
        var y = d(0, r.head(l));
        if ((0, n.isLeft)(y))
          return y;
        for (var p = [y.right], ln = 1; ln < l.length; ln++) {
          var o = d(ln, l[ln]);
          if ((0, n.isLeft)(o))
            return o;
          p.push(o.right);
        }
        return (0, n.right)(p);
      };
    };
    n.traverseReadonlyNonEmptyArrayWithIndex = cn;
    var vn = function(d) {
      var l = (0, n.traverseReadonlyNonEmptyArrayWithIndex)(d);
      return function(y) {
        return r.isNonEmpty(y) ? l(y) : n.ApT;
      };
    };
    n.traverseReadonlyArrayWithIndex = vn, n.traverseArrayWithIndex = n.traverseReadonlyArrayWithIndex;
    var X = function(d) {
      return (0, n.traverseReadonlyArrayWithIndex)(function(l, y) {
        return d(y);
      });
    };
    n.traverseArray = X, n.sequenceArray = /* @__PURE__ */ (0, n.traverseArray)(u.identity), n.chainW = n.flatMap, n.chain = n.flatMap, n.chainFirst = n.tap, n.chainFirstW = n.tap;
    function dn(d, l) {
      return (0, n.tryCatch)(function() {
        return JSON.parse(d);
      }, l);
    }
    var Fn = function(d, l) {
      return (0, n.tryCatch)(function() {
        var y = JSON.stringify(d);
        if (typeof y != "string")
          throw new Error("Converting unsupported structure to JSON");
        return y;
      }, l);
    };
    n.stringifyJSON = Fn, n.either = {
      URI: n.URI,
      map: N,
      of: n.of,
      ap: S,
      chain: n.flatMap,
      reduce: i,
      foldMap: E,
      reduceRight: e,
      traverse: a,
      sequence: n.sequence,
      bimap: q,
      mapLeft: T,
      alt: F,
      extend: I,
      chainRec: P,
      throwError: n.throwError
    }, n.getApplySemigroup = /* @__PURE__ */ (0, f.getApplySemigroup)(n.Apply), n.getApplyMonoid = /* @__PURE__ */ (0, O.getApplicativeMonoid)(n.Applicative);
    var xn = function(d, l) {
      return (0, f.getApplySemigroup)((0, n.getApplicativeValidation)(d))(l);
    };
    n.getValidationSemigroup = xn;
    var $n = function(d, l) {
      return (0, O.getApplicativeMonoid)((0, n.getApplicativeValidation)(d))(l);
    };
    n.getValidationMonoid = $n;
    function nr(d) {
      var l = (0, n.getApplicativeValidation)(d).ap, y = (0, n.getAltValidation)(d).alt;
      return {
        URI: n.URI,
        _E: void 0,
        map: N,
        of: n.of,
        chain: n.flatMap,
        bimap: q,
        mapLeft: T,
        reduce: i,
        foldMap: E,
        reduceRight: e,
        extend: I,
        traverse: a,
        sequence: n.sequence,
        chainRec: P,
        throwError: n.throwError,
        ap: l,
        alt: y
      };
    }
  })(Mn)), Mn;
}
var G = {}, qr;
function ua() {
  if (qr) return G;
  qr = 1;
  var n = G && G.__createBinding || (Object.create ? (function(_, C, j, B) {
    B === void 0 && (B = j);
    var x = Object.getOwnPropertyDescriptor(C, j);
    (!x || ("get" in x ? !C.__esModule : x.writable || x.configurable)) && (x = { enumerable: !0, get: function() {
      return C[j];
    } }), Object.defineProperty(_, B, x);
  }) : (function(_, C, j, B) {
    B === void 0 && (B = j), _[B] = C[j];
  })), A = G && G.__setModuleDefault || (Object.create ? (function(_, C) {
    Object.defineProperty(_, "default", { enumerable: !0, value: C });
  }) : function(_, C) {
    _.default = C;
  }), R = G && G.__importStar || function(_) {
    if (_ && _.__esModule) return _;
    var C = {};
    if (_ != null) for (var j in _) j !== "default" && Object.prototype.hasOwnProperty.call(_, j) && n(C, _, j);
    return A(C, _), C;
  };
  Object.defineProperty(G, "__esModule", { value: !0 }), G.right = h, G.left = c, G.rightF = u, G.leftF = t, G.fromNullable = r, G.fromNullableK = v, G.chainNullableK = b, G.map = N, G.ap = S, G.chain = i, G.flatMap = E, G.alt = e, G.bimap = a, G.mapBoth = q, G.mapLeft = T, G.mapError = F, G.altValidation = I, G.match = P, G.matchE = Z, G.getOrElse = D, G.orElse = J, G.orElseFirst = Q, G.tapError = en, G.orLeft = L, G.swap = k, G.toUnion = H, G.getEitherM = rn;
  var M = /* @__PURE__ */ Vn(), O = R(/* @__PURE__ */ Qr()), f = /* @__PURE__ */ un(), g = /* @__PURE__ */ qn();
  function h(_) {
    return (0, f.flow)(O.right, _.of);
  }
  function c(_) {
    return (0, f.flow)(O.left, _.of);
  }
  function u(_) {
    return function(C) {
      return _.map(C, O.right);
    };
  }
  function t(_) {
    return function(C) {
      return _.map(C, O.left);
    };
  }
  function r(_) {
    return function(C) {
      return (0, f.flow)(O.fromNullable(C), _.of);
    };
  }
  function v(_) {
    var C = r(_);
    return function(j) {
      var B = C(j);
      return function(x) {
        return (0, f.flow)(x, B);
      };
    };
  }
  function b(_) {
    var C = i(_), j = v(_);
    return function(B) {
      var x = j(B);
      return function(hn) {
        return C(x(hn));
      };
    };
  }
  function N(_) {
    return (0, g.map)(_, O.Functor);
  }
  function S(_) {
    return (0, M.ap)(_, O.Apply);
  }
  function i(_) {
    var C = E(_);
    return function(j) {
      return function(B) {
        return C(B, j);
      };
    };
  }
  function E(_) {
    return function(C, j) {
      return _.chain(C, function(B) {
        return O.isLeft(B) ? _.of(B) : j(B.right);
      });
    };
  }
  function e(_) {
    return function(C) {
      return function(j) {
        return _.chain(j, function(B) {
          return O.isLeft(B) ? C() : _.of(B);
        });
      };
    };
  }
  function a(_) {
    var C = q(_);
    return function(j, B) {
      return function(x) {
        return C(x, j, B);
      };
    };
  }
  function q(_) {
    return function(C, j, B) {
      return _.map(C, O.bimap(j, B));
    };
  }
  function T(_) {
    var C = F(_);
    return function(j) {
      return function(B) {
        return C(B, j);
      };
    };
  }
  function F(_) {
    return function(C, j) {
      return _.map(C, O.mapLeft(j));
    };
  }
  function I(_, C) {
    return function(j) {
      return function(B) {
        return _.chain(B, O.match(function(x) {
          return _.map(j(), O.mapLeft(function(hn) {
            return C.concat(x, hn);
          }));
        }, h(_)));
      };
    };
  }
  function P(_) {
    return function(C, j) {
      return function(B) {
        return _.map(B, O.match(C, j));
      };
    };
  }
  function Z(_) {
    return function(C, j) {
      return function(B) {
        return _.chain(B, O.match(C, j));
      };
    };
  }
  function D(_) {
    return function(C) {
      return function(j) {
        return _.chain(j, O.match(C, _.of));
      };
    };
  }
  function J(_) {
    return function(C) {
      return function(j) {
        return _.chain(j, function(B) {
          return O.isLeft(B) ? C(B.left) : _.of(B);
        });
      };
    };
  }
  function Q(_) {
    var C = en(_);
    return function(j) {
      return function(B) {
        return C(B, j);
      };
    };
  }
  function en(_) {
    var C = J(_);
    return function(j, B) {
      return (0, f.pipe)(j, C(function(x) {
        return _.map(B(x), function(hn) {
          return O.isLeft(hn) ? hn : O.left(x);
        });
      }));
    };
  }
  function L(_) {
    return function(C) {
      return function(j) {
        return _.chain(j, O.match(function(B) {
          return _.map(C(B), O.left);
        }, function(B) {
          return _.of(O.right(B));
        }));
      };
    };
  }
  function k(_) {
    return function(C) {
      return _.map(C, O.swap);
    };
  }
  function H(_) {
    return function(C) {
      return _.map(C, O.toUnion);
    };
  }
  function rn(_) {
    var C = S(_), j = N(_), B = i(_), x = e(_), hn = a(_), Tn = T(_), wn = Z(_), Nn = D(_), Pn = J(_);
    return {
      map: function($, nn) {
        return (0, f.pipe)($, j(nn));
      },
      ap: function($, nn) {
        return (0, f.pipe)($, C(nn));
      },
      of: h(_),
      chain: function($, nn) {
        return (0, f.pipe)($, B(nn));
      },
      alt: function($, nn) {
        return (0, f.pipe)($, x(nn));
      },
      bimap: function($, nn, yn) {
        return (0, f.pipe)($, hn(nn, yn));
      },
      mapLeft: function($, nn) {
        return (0, f.pipe)($, Tn(nn));
      },
      fold: function($, nn, yn) {
        return (0, f.pipe)($, wn(nn, yn));
      },
      getOrElse: function($, nn) {
        return (0, f.pipe)($, Nn(nn));
      },
      orElse: function($, nn) {
        return (0, f.pipe)($, Pn(nn));
      },
      swap: k(_),
      rightM: u(_),
      leftM: t(_),
      left: c(_)
    };
  }
  return G;
}
var Un = {}, Fr;
function fa() {
  if (Fr) return Un;
  Fr = 1, Object.defineProperty(Un, "__esModule", { value: !0 }), Un.filter = g, Un.filterMap = h, Un.partition = c, Un.partitionMap = u, Un.getFilterableComposition = t;
  var n = /* @__PURE__ */ Hr(), A = /* @__PURE__ */ un(), R = /* @__PURE__ */ qn(), M = /* @__PURE__ */ Zr(), O = /* @__PURE__ */ zr(), f = /* @__PURE__ */ sn();
  function g(r, v) {
    return function(b) {
      return function(N) {
        return r.map(N, function(S) {
          return v.filter(S, b);
        });
      };
    };
  }
  function h(r, v) {
    return function(b) {
      return function(N) {
        return r.map(N, function(S) {
          return v.filterMap(S, b);
        });
      };
    };
  }
  function c(r, v) {
    var b = g(r, v);
    return function(N) {
      var S = b((0, O.not)(N)), i = b(N);
      return function(E) {
        return (0, f.separated)(S(E), i(E));
      };
    };
  }
  function u(r, v) {
    var b = h(r, v);
    return function(N) {
      return function(S) {
        return (0, f.separated)((0, A.pipe)(S, b(function(i) {
          return (0, M.getLeft)(N(i));
        })), (0, A.pipe)(S, b(function(i) {
          return (0, M.getRight)(N(i));
        })));
      };
    };
  }
  function t(r, v) {
    var b = (0, R.getFunctorComposition)(r, v).map, N = (0, n.compact)(r, v), S = (0, n.separate)(r, v, v), i = g(r, v), E = h(r, v), e = c(r, v), a = u(r, v);
    return {
      map: b,
      compact: N,
      separate: S,
      filter: function(q, T) {
        return (0, A.pipe)(q, i(T));
      },
      filterMap: function(q, T) {
        return (0, A.pipe)(q, E(T));
      },
      partition: function(q, T) {
        return (0, A.pipe)(q, e(T));
      },
      partitionMap: function(q, T) {
        return (0, A.pipe)(q, a(T));
      }
    };
  }
  return Un;
}
var Ln = {}, Ur;
function Xr() {
  if (Ur) return Ln;
  Ur = 1, Object.defineProperty(Ln, "__esModule", { value: !0 }), Ln.fromIOK = R, Ln.chainIOK = M, Ln.chainFirstIOK = O, Ln.tapIO = f;
  var n = /* @__PURE__ */ Dn(), A = /* @__PURE__ */ un();
  function R(g) {
    return function(h) {
      return (0, A.flow)(h, g.fromIO);
    };
  }
  function M(g, h) {
    return function(c) {
      var u = (0, A.flow)(c, g.fromIO);
      return function(t) {
        return h.chain(t, u);
      };
    };
  }
  function O(g, h) {
    var c = f(g, h);
    return function(u) {
      return function(t) {
        return c(t, u);
      };
    };
  }
  function f(g, h) {
    var c = (0, n.tap)(h);
    return function(u, t) {
      return c(u, (0, A.flow)(t, g.fromIO));
    };
  }
  return Ln;
}
var jn = {}, Wr;
function ca() {
  if (Wr) return jn;
  Wr = 1, Object.defineProperty(jn, "__esModule", { value: !0 }), jn.fromTaskK = R, jn.chainTaskK = M, jn.chainFirstTaskK = O, jn.tapTask = f;
  var n = /* @__PURE__ */ Dn(), A = /* @__PURE__ */ un();
  function R(g) {
    return function(h) {
      return (0, A.flow)(h, g.fromTask);
    };
  }
  function M(g, h) {
    return function(c) {
      var u = (0, A.flow)(c, g.fromTask);
      return function(t) {
        return h.chain(t, u);
      };
    };
  }
  function O(g, h) {
    var c = f(g, h);
    return function(u) {
      return function(t) {
        return c(t, u);
      };
    };
  }
  function f(g, h) {
    var c = (0, n.tap)(h);
    return function(u, t) {
      return c(u, (0, A.flow)(t, g.fromTask));
    };
  }
  return jn;
}
var An = {}, Tr;
function la() {
  return Tr || (Tr = 1, (function(n) {
    var A = An && An.__createBinding || (Object.create ? (function(L, k, H, rn) {
      rn === void 0 && (rn = H);
      var _ = Object.getOwnPropertyDescriptor(k, H);
      (!_ || ("get" in _ ? !k.__esModule : _.writable || _.configurable)) && (_ = { enumerable: !0, get: function() {
        return k[H];
      } }), Object.defineProperty(L, rn, _);
    }) : (function(L, k, H, rn) {
      rn === void 0 && (rn = H), L[rn] = k[H];
    })), R = An && An.__setModuleDefault || (Object.create ? (function(L, k) {
      Object.defineProperty(L, "default", { enumerable: !0, value: k });
    }) : function(L, k) {
      L.default = k;
    }), M = An && An.__importStar || function(L) {
      if (L && L.__esModule) return L;
      var k = {};
      if (L != null) for (var H in L) H !== "default" && Object.prototype.hasOwnProperty.call(L, H) && A(k, L, H);
      return R(k, L), k;
    };
    Object.defineProperty(n, "__esModule", { value: !0 }), n.chainFirst = n.chain = n.sequenceSeqArray = n.traverseSeqArray = n.traverseSeqArrayWithIndex = n.sequenceArray = n.traverseArray = n.traverseArrayWithIndex = n.traverseReadonlyArrayWithIndexSeq = n.traverseReadonlyNonEmptyArrayWithIndexSeq = n.traverseReadonlyArrayWithIndex = n.traverseReadonlyNonEmptyArrayWithIndex = n.ApT = n.apS = n.bind = n.let = n.bindTo = n.Do = n.never = n.FromTask = n.chainFirstIOK = n.chainIOK = n.fromIOK = n.tapIO = n.tap = n.flatMapIO = n.FromIO = n.MonadTask = n.fromTask = n.MonadIO = n.Monad = n.Chain = n.ApplicativeSeq = n.ApplySeq = n.ApplicativePar = n.apSecond = n.apFirst = n.ApplyPar = n.Pointed = n.flap = n.asUnit = n.as = n.Functor = n.URI = n.flatten = n.flatMap = n.of = n.ap = n.map = n.fromIO = void 0, n.getMonoid = n.getSemigroup = n.taskSeq = n.task = void 0, n.delay = v, n.getRaceMonoid = a;
    var O = /* @__PURE__ */ pn(), f = /* @__PURE__ */ Vn(), g = M(/* @__PURE__ */ Dn()), h = /* @__PURE__ */ Xr(), c = /* @__PURE__ */ un(), u = /* @__PURE__ */ qn(), t = M(/* @__PURE__ */ Wn()), r = function(L) {
      return function() {
        return Promise.resolve().then(L);
      };
    };
    n.fromIO = r;
    function v(L) {
      return function(k) {
        return function() {
          return new Promise(function(H) {
            setTimeout(function() {
              Promise.resolve().then(k).then(H);
            }, L);
          });
        };
      };
    }
    var b = function(L, k) {
      return (0, c.pipe)(L, (0, n.map)(k));
    }, N = function(L, k) {
      return (0, c.pipe)(L, (0, n.ap)(k));
    }, S = function(L, k) {
      return (0, n.flatMap)(L, function(H) {
        return (0, c.pipe)(k, (0, n.map)(H));
      });
    }, i = function(L) {
      return function(k) {
        return function() {
          return Promise.resolve().then(k).then(L);
        };
      };
    };
    n.map = i;
    var E = function(L) {
      return function(k) {
        return function() {
          return Promise.all([Promise.resolve().then(k), Promise.resolve().then(L)]).then(function(H) {
            var rn = H[0], _ = H[1];
            return rn(_);
          });
        };
      };
    };
    n.ap = E;
    var e = function(L) {
      return function() {
        return Promise.resolve(L);
      };
    };
    n.of = e, n.flatMap = (0, c.dual)(2, function(L, k) {
      return function() {
        return Promise.resolve().then(L).then(function(H) {
          return k(H)();
        });
      };
    }), n.flatten = (0, n.flatMap)(c.identity), n.URI = "Task";
    function a() {
      return {
        concat: function(L, k) {
          return function() {
            return Promise.race([Promise.resolve().then(L), Promise.resolve().then(k)]);
          };
        },
        empty: n.never
      };
    }
    n.Functor = {
      URI: n.URI,
      map: b
    }, n.as = (0, c.dual)(2, (0, u.as)(n.Functor)), n.asUnit = (0, u.asUnit)(n.Functor), n.flap = (0, u.flap)(n.Functor), n.Pointed = {
      URI: n.URI,
      of: n.of
    }, n.ApplyPar = {
      URI: n.URI,
      map: b,
      ap: N
    }, n.apFirst = (0, f.apFirst)(n.ApplyPar), n.apSecond = (0, f.apSecond)(n.ApplyPar), n.ApplicativePar = {
      URI: n.URI,
      map: b,
      ap: N,
      of: n.of
    }, n.ApplySeq = {
      URI: n.URI,
      map: b,
      ap: S
    }, n.ApplicativeSeq = {
      URI: n.URI,
      map: b,
      ap: S,
      of: n.of
    }, n.Chain = {
      URI: n.URI,
      map: b,
      ap: N,
      chain: n.flatMap
    }, n.Monad = {
      URI: n.URI,
      map: b,
      of: n.of,
      ap: N,
      chain: n.flatMap
    }, n.MonadIO = {
      URI: n.URI,
      map: b,
      of: n.of,
      ap: N,
      chain: n.flatMap,
      fromIO: n.fromIO
    }, n.fromTask = c.identity, n.MonadTask = {
      URI: n.URI,
      map: b,
      of: n.of,
      ap: N,
      chain: n.flatMap,
      fromIO: n.fromIO,
      fromTask: n.fromTask
    }, n.FromIO = {
      URI: n.URI,
      fromIO: n.fromIO
    };
    var q = {
      flatMap: n.flatMap
    }, T = {
      fromIO: n.FromIO.fromIO
    };
    n.flatMapIO = t.flatMapIO(T, q), n.tap = (0, c.dual)(2, g.tap(n.Chain)), n.tapIO = (0, c.dual)(2, (0, h.tapIO)(n.FromIO, n.Chain)), n.fromIOK = /* @__PURE__ */ (0, h.fromIOK)(n.FromIO), n.chainIOK = n.flatMapIO, n.chainFirstIOK = n.tapIO, n.FromTask = {
      URI: n.URI,
      fromIO: n.fromIO,
      fromTask: n.fromTask
    };
    var F = function() {
      return new Promise(function(L) {
      });
    };
    n.never = F, n.Do = (0, n.of)(t.emptyRecord), n.bindTo = (0, u.bindTo)(n.Functor);
    var I = /* @__PURE__ */ (0, u.let)(n.Functor);
    n.let = I, n.bind = g.bind(n.Chain), n.apS = (0, f.apS)(n.ApplyPar), n.ApT = (0, n.of)(t.emptyReadonlyArray);
    var P = function(L) {
      return function(k) {
        return function() {
          return Promise.all(k.map(function(H, rn) {
            return Promise.resolve().then(function() {
              return L(rn, H)();
            });
          }));
        };
      };
    };
    n.traverseReadonlyNonEmptyArrayWithIndex = P;
    var Z = function(L) {
      var k = (0, n.traverseReadonlyNonEmptyArrayWithIndex)(L);
      return function(H) {
        return t.isNonEmpty(H) ? k(H) : n.ApT;
      };
    };
    n.traverseReadonlyArrayWithIndex = Z;
    var D = function(L) {
      return function(k) {
        return function() {
          return t.tail(k).reduce(function(H, rn, _) {
            return H.then(function(C) {
              return Promise.resolve().then(L(_ + 1, rn)).then(function(j) {
                return C.push(j), C;
              });
            });
          }, Promise.resolve().then(L(0, t.head(k))).then(t.singleton));
        };
      };
    };
    n.traverseReadonlyNonEmptyArrayWithIndexSeq = D;
    var J = function(L) {
      var k = (0, n.traverseReadonlyNonEmptyArrayWithIndexSeq)(L);
      return function(H) {
        return t.isNonEmpty(H) ? k(H) : n.ApT;
      };
    };
    n.traverseReadonlyArrayWithIndexSeq = J, n.traverseArrayWithIndex = n.traverseReadonlyArrayWithIndex;
    var Q = function(L) {
      return (0, n.traverseReadonlyArrayWithIndex)(function(k, H) {
        return L(H);
      });
    };
    n.traverseArray = Q, n.sequenceArray = /* @__PURE__ */ (0, n.traverseArray)(c.identity), n.traverseSeqArrayWithIndex = n.traverseReadonlyArrayWithIndexSeq;
    var en = function(L) {
      return (0, n.traverseReadonlyArrayWithIndexSeq)(function(k, H) {
        return L(H);
      });
    };
    n.traverseSeqArray = en, n.sequenceSeqArray = /* @__PURE__ */ (0, n.traverseSeqArray)(c.identity), n.chain = n.flatMap, n.chainFirst = n.tap, n.task = {
      URI: n.URI,
      map: b,
      of: n.of,
      ap: N,
      chain: n.flatMap,
      fromIO: n.fromIO,
      fromTask: n.fromTask
    }, n.taskSeq = {
      URI: n.URI,
      map: b,
      of: n.of,
      ap: S,
      chain: n.flatMap,
      fromIO: n.fromIO,
      fromTask: n.fromTask
    }, n.getSemigroup = (0, f.getApplySemigroup)(n.ApplySeq), n.getMonoid = (0, O.getApplicativeMonoid)(n.ApplicativeSeq);
  })(An)), An;
}
var wr;
function oa() {
  return wr || (wr = 1, (function(n) {
    var A = mn && mn.__createBinding || (Object.create ? (function(W, K, w, V) {
      V === void 0 && (V = w);
      var Y = Object.getOwnPropertyDescriptor(K, w);
      (!Y || ("get" in Y ? !K.__esModule : Y.writable || Y.configurable)) && (Y = { enumerable: !0, get: function() {
        return K[w];
      } }), Object.defineProperty(W, V, Y);
    }) : (function(W, K, w, V) {
      V === void 0 && (V = w), W[V] = K[w];
    })), R = mn && mn.__setModuleDefault || (Object.create ? (function(W, K) {
      Object.defineProperty(W, "default", { enumerable: !0, value: K });
    }) : function(W, K) {
      W.default = K;
    }), M = mn && mn.__importStar || function(W) {
      if (W && W.__esModule) return W;
      var K = {};
      if (W != null) for (var w in W) w !== "default" && Object.prototype.hasOwnProperty.call(W, w) && A(K, W, w);
      return R(K, W), K;
    }, O = mn && mn.__awaiter || function(W, K, w, V) {
      function Y(z) {
        return z instanceof w ? z : new w(function(an) {
          an(z);
        });
      }
      return new (w || (w = Promise))(function(z, an) {
        function cn(dn) {
          try {
            X(V.next(dn));
          } catch (Fn) {
            an(Fn);
          }
        }
        function vn(dn) {
          try {
            X(V.throw(dn));
          } catch (Fn) {
            an(Fn);
          }
        }
        function X(dn) {
          dn.done ? z(dn.value) : Y(dn.value).then(cn, vn);
        }
        X((V = V.apply(W, K || [])).next());
      });
    }, f = mn && mn.__generator || function(W, K) {
      var w = { label: 0, sent: function() {
        if (z[0] & 1) throw z[1];
        return z[1];
      }, trys: [], ops: [] }, V, Y, z, an;
      return an = { next: cn(0), throw: cn(1), return: cn(2) }, typeof Symbol == "function" && (an[Symbol.iterator] = function() {
        return this;
      }), an;
      function cn(X) {
        return function(dn) {
          return vn([X, dn]);
        };
      }
      function vn(X) {
        if (V) throw new TypeError("Generator is already executing.");
        for (; an && (an = 0, X[0] && (w = 0)), w; ) try {
          if (V = 1, Y && (z = X[0] & 2 ? Y.return : X[0] ? Y.throw || ((z = Y.return) && z.call(Y), 0) : Y.next) && !(z = z.call(Y, X[1])).done) return z;
          switch (Y = 0, z && (X = [X[0] & 2, z.value]), X[0]) {
            case 0:
            case 1:
              z = X;
              break;
            case 4:
              return w.label++, { value: X[1], done: !1 };
            case 5:
              w.label++, Y = X[1], X = [0];
              continue;
            case 7:
              X = w.ops.pop(), w.trys.pop();
              continue;
            default:
              if (z = w.trys, !(z = z.length > 0 && z[z.length - 1]) && (X[0] === 6 || X[0] === 2)) {
                w = 0;
                continue;
              }
              if (X[0] === 3 && (!z || X[1] > z[0] && X[1] < z[3])) {
                w.label = X[1];
                break;
              }
              if (X[0] === 6 && w.label < z[1]) {
                w.label = z[1], z = X;
                break;
              }
              if (z && w.label < z[2]) {
                w.label = z[2], w.ops.push(X);
                break;
              }
              z[2] && w.ops.pop(), w.trys.pop();
              continue;
          }
          X = K.call(W, w);
        } catch (dn) {
          X = [6, dn], Y = 0;
        } finally {
          V = z = 0;
        }
        if (X[0] & 5) throw X[1];
        return { value: X[0] ? X[1] : void 0, done: !0 };
      }
    };
    Object.defineProperty(n, "__esModule", { value: !0 }), n.throwError = n.of = n.altW = n.alt = n.flatten = n.flattenW = n.flatMap = n.apW = n.ap = n.mapLeft = n.mapError = n.bimap = n.mapBoth = n.map = n.fromIOEitherK = n.chainTaskOptionK = n.chainTaskOptionKW = n.fromTaskOptionK = n.swap = n.orLeft = n.orElseFirstTaskK = n.orElseFirstIOK = n.tapError = n.orElseW = n.orElse = n.chainNullableK = n.fromNullableK = n.fromNullable = n.toUnion = n.tryCatchK = n.tryCatch = n.getOrElseW = n.getOrElse = n.foldW = n.matchEW = n.fold = n.matchE = n.matchW = n.match = n.fromTaskOption = n.fromIOEither = n.fromEither = n.fromTask = n.fromIO = n.leftIO = n.rightIO = n.leftTask = n.rightTask = n.right = n.left = void 0, n.fromEitherK = n.filterOrElseW = n.filterOrElse = n.fromPredicate = n.chainFirstEitherKW = n.chainFirstEitherK = n.chainEitherKW = n.chainEitherK = n.flatMapTaskOption = n.flatMapIOEither = n.flatMapTask = n.flatMapIO = n.flatMapEither = n.flatMapOption = n.flatMapNullable = n.liftOption = n.liftNullable = n.chainOptionKW = n.chainOptionK = n.fromOptionK = n.fromOption = n.Alt = n.Bifunctor = n.tapTask = n.tapIO = n.tapEither = n.tap = n.FromTask = n.FromIO = n.FromEither = n.MonadThrow = n.MonadTask = n.MonadIO = n.Monad = n.Chain = n.ApplicativeSeq = n.ApplySeq = n.ApplicativePar = n.apSecondW = n.apSecond = n.apFirstW = n.apFirst = n.ApplyPar = n.Pointed = n.flap = n.asUnit = n.as = n.Functor = n.getCompactable = n.URI = void 0, n.getSemigroup = n.getApplyMonoid = n.getApplySemigroup = n.taskEitherSeq = n.taskEither = n.orElseFirstW = n.orElseFirst = n.chainFirstW = n.chainFirst = n.chainW = n.chain = n.sequenceSeqArray = n.traverseSeqArray = n.traverseSeqArrayWithIndex = n.sequenceArray = n.traverseArray = n.traverseArrayWithIndex = n.traverseReadonlyArrayWithIndexSeq = n.traverseReadonlyNonEmptyArrayWithIndexSeq = n.traverseReadonlyArrayWithIndex = n.traverseReadonlyNonEmptyArrayWithIndex = n.ApT = n.apSW = n.apS = n.bindW = n.bind = n.let = n.bindTo = n.Do = n.bracketW = n.bracket = n.chainIOEitherK = n.chainIOEitherKW = n.chainFirstTaskK = n.chainTaskK = n.fromTaskK = n.chainFirstIOK = n.chainIOK = n.fromIOK = void 0, n.getApplicativeTaskValidation = H, n.getAltTaskValidation = rn, n.getFilterable = C, n.taskify = Tn, n.getTaskValidation = Cn;
    var g = /* @__PURE__ */ pn(), h = /* @__PURE__ */ Vn(), c = M(/* @__PURE__ */ Dn()), u = /* @__PURE__ */ Hr(), t = M(/* @__PURE__ */ Qr()), r = M(/* @__PURE__ */ ua()), v = /* @__PURE__ */ fa(), b = /* @__PURE__ */ er(), N = /* @__PURE__ */ Xr(), S = /* @__PURE__ */ ca(), i = /* @__PURE__ */ un(), E = /* @__PURE__ */ qn(), e = M(/* @__PURE__ */ Wn()), a = M(/* @__PURE__ */ la());
    n.left = r.left(a.Pointed), n.right = r.right(a.Pointed), n.rightTask = r.rightF(a.Functor), n.leftTask = r.leftF(a.Functor), n.rightIO = (0, i.flow)(a.fromIO, n.rightTask), n.leftIO = (0, i.flow)(a.fromIO, n.leftTask), n.fromIO = n.rightIO, n.fromTask = n.rightTask, n.fromEither = a.of, n.fromIOEither = a.fromIO;
    var q = function(W) {
      return a.map(t.fromOption(W));
    };
    n.fromTaskOption = q, n.match = /* @__PURE__ */ r.match(a.Functor), n.matchW = n.match, n.matchE = r.matchE(a.Monad), n.fold = n.matchE, n.matchEW = n.matchE, n.foldW = n.matchEW, n.getOrElse = /* @__PURE__ */ r.getOrElse(a.Monad), n.getOrElseW = n.getOrElse;
    var T = function(W, K) {
      return function() {
        return O(void 0, void 0, void 0, function() {
          var w;
          return f(this, function(V) {
            switch (V.label) {
              case 0:
                return V.trys.push([0, 2, , 3]), [4, W().then(e.right)];
              case 1:
                return [2, V.sent()];
              case 2:
                return w = V.sent(), [2, e.left(K(w))];
              case 3:
                return [
                  2
                  /*return*/
                ];
            }
          });
        });
      };
    };
    n.tryCatch = T;
    var F = function(W, K) {
      return function() {
        for (var w = [], V = 0; V < arguments.length; V++)
          w[V] = arguments[V];
        return (0, n.tryCatch)(function() {
          return W.apply(void 0, w);
        }, K);
      };
    };
    n.tryCatchK = F, n.toUnion = r.toUnion(a.Functor), n.fromNullable = r.fromNullable(a.Pointed), n.fromNullableK = r.fromNullableK(a.Pointed), n.chainNullableK = /* @__PURE__ */ r.chainNullableK(a.Monad), n.orElse = /* @__PURE__ */ r.orElse(a.Monad), n.orElseW = n.orElse, n.tapError = (0, i.dual)(2, r.tapError(a.Monad));
    var I = function(W) {
      return (0, n.tapError)((0, n.fromIOK)(W));
    };
    n.orElseFirstIOK = I;
    var P = function(W) {
      return (0, n.tapError)((0, n.fromTaskK)(W));
    };
    n.orElseFirstTaskK = P, n.orLeft = /* @__PURE__ */ r.orLeft(a.Monad), n.swap = r.swap(a.Functor);
    var Z = function(W) {
      var K = (0, n.fromTaskOption)(W);
      return function(w) {
        return (0, i.flow)(w, K);
      };
    };
    n.fromTaskOptionK = Z;
    var D = function(W) {
      return function(K) {
        return function(w) {
          return (0, n.flatMap)(w, (0, n.fromTaskOptionK)(W)(K));
        };
      };
    };
    n.chainTaskOptionKW = D, n.chainTaskOptionK = n.chainTaskOptionKW;
    var J = function(W) {
      return (0, i.flow)(W, n.fromIOEither);
    };
    n.fromIOEitherK = J;
    var Q = function(W, K) {
      return (0, i.pipe)(W, (0, n.map)(K));
    }, en = function(W, K) {
      return (0, i.pipe)(W, (0, n.ap)(K));
    }, L = function(W, K) {
      return (0, n.flatMap)(W, function(w) {
        return (0, i.pipe)(K, (0, n.map)(w));
      });
    }, k = function(W, K) {
      return (0, i.pipe)(W, (0, n.alt)(K));
    };
    n.map = r.map(a.Functor), n.mapBoth = (0, i.dual)(3, r.mapBoth(a.Functor)), n.bimap = n.mapBoth, n.mapError = (0, i.dual)(2, r.mapError(a.Functor)), n.mapLeft = n.mapError, n.ap = /* @__PURE__ */ r.ap(a.ApplyPar), n.apW = n.ap, n.flatMap = (0, i.dual)(2, r.flatMap(a.Monad)), n.flattenW = /* @__PURE__ */ (0, n.flatMap)(i.identity), n.flatten = n.flattenW, n.alt = /* @__PURE__ */ r.alt(a.Monad), n.altW = n.alt, n.of = n.right, n.throwError = n.left, n.URI = "TaskEither";
    function H(W, K) {
      var w = (0, h.ap)(W, t.getApplicativeValidation(K));
      return {
        URI: n.URI,
        _E: void 0,
        map: Q,
        ap: function(V, Y) {
          return (0, i.pipe)(V, w(Y));
        },
        of: n.of
      };
    }
    function rn(W) {
      var K = r.altValidation(a.Monad, W);
      return {
        URI: n.URI,
        _E: void 0,
        map: Q,
        alt: function(w, V) {
          return (0, i.pipe)(w, K(V));
        }
      };
    }
    var _ = function(W) {
      var K = t.getCompactable(W);
      return {
        URI: n.URI,
        _E: void 0,
        compact: (0, u.compact)(a.Functor, K),
        separate: (0, u.separate)(a.Functor, K, t.Functor)
      };
    };
    n.getCompactable = _;
    function C(W) {
      var K = t.getFilterable(W), w = (0, n.getCompactable)(W), V = (0, v.filter)(a.Functor, K), Y = (0, v.filterMap)(a.Functor, K), z = (0, v.partition)(a.Functor, K), an = (0, v.partitionMap)(a.Functor, K);
      return {
        URI: n.URI,
        _E: void 0,
        map: Q,
        compact: w.compact,
        separate: w.separate,
        filter: function(cn, vn) {
          return (0, i.pipe)(cn, V(vn));
        },
        filterMap: function(cn, vn) {
          return (0, i.pipe)(cn, Y(vn));
        },
        partition: function(cn, vn) {
          return (0, i.pipe)(cn, z(vn));
        },
        partitionMap: function(cn, vn) {
          return (0, i.pipe)(cn, an(vn));
        }
      };
    }
    n.Functor = {
      URI: n.URI,
      map: Q
    }, n.as = (0, i.dual)(2, (0, E.as)(n.Functor)), n.asUnit = (0, E.asUnit)(n.Functor), n.flap = (0, E.flap)(n.Functor), n.Pointed = {
      URI: n.URI,
      of: n.of
    }, n.ApplyPar = {
      URI: n.URI,
      map: Q,
      ap: en
    }, n.apFirst = (0, h.apFirst)(n.ApplyPar), n.apFirstW = n.apFirst, n.apSecond = (0, h.apSecond)(n.ApplyPar), n.apSecondW = n.apSecond, n.ApplicativePar = {
      URI: n.URI,
      map: Q,
      ap: en,
      of: n.of
    }, n.ApplySeq = {
      URI: n.URI,
      map: Q,
      ap: L
    }, n.ApplicativeSeq = {
      URI: n.URI,
      map: Q,
      ap: L,
      of: n.of
    }, n.Chain = {
      URI: n.URI,
      map: Q,
      ap: en,
      chain: n.flatMap
    }, n.Monad = {
      URI: n.URI,
      map: Q,
      ap: en,
      chain: n.flatMap,
      of: n.of
    }, n.MonadIO = {
      URI: n.URI,
      map: Q,
      ap: en,
      chain: n.flatMap,
      of: n.of,
      fromIO: n.fromIO
    }, n.MonadTask = {
      URI: n.URI,
      map: Q,
      ap: en,
      chain: n.flatMap,
      of: n.of,
      fromIO: n.fromIO,
      fromTask: n.fromTask
    }, n.MonadThrow = {
      URI: n.URI,
      map: Q,
      ap: en,
      chain: n.flatMap,
      of: n.of,
      throwError: n.throwError
    }, n.FromEither = {
      URI: n.URI,
      fromEither: n.fromEither
    }, n.FromIO = {
      URI: n.URI,
      fromIO: n.fromIO
    }, n.FromTask = {
      URI: n.URI,
      fromIO: n.fromIO,
      fromTask: n.fromTask
    }, n.tap = (0, i.dual)(2, c.tap(n.Chain)), n.tapEither = (0, i.dual)(2, (0, b.tapEither)(n.FromEither, n.Chain)), n.tapIO = (0, i.dual)(2, (0, N.tapIO)(n.FromIO, n.Chain)), n.tapTask = (0, i.dual)(2, (0, S.tapTask)(n.FromTask, n.Chain)), n.Bifunctor = {
      URI: n.URI,
      bimap: n.mapBoth,
      mapLeft: n.mapError
    }, n.Alt = {
      URI: n.URI,
      map: Q,
      alt: k
    }, n.fromOption = /* @__PURE__ */ (0, b.fromOption)(n.FromEither), n.fromOptionK = /* @__PURE__ */ (0, b.fromOptionK)(n.FromEither), n.chainOptionK = (0, b.chainOptionK)(n.FromEither, n.Chain), n.chainOptionKW = n.chainOptionK;
    var j = {
      fromEither: n.FromEither.fromEither
    };
    n.liftNullable = e.liftNullable(j), n.liftOption = e.liftOption(j);
    var B = {
      flatMap: n.flatMap
    }, x = {
      fromIO: n.FromIO.fromIO
    }, hn = {
      fromTask: n.fromTask
    };
    n.flatMapNullable = e.flatMapNullable(j, B), n.flatMapOption = e.flatMapOption(j, B), n.flatMapEither = e.flatMapEither(j, B), n.flatMapIO = e.flatMapIO(x, B), n.flatMapTask = e.flatMapTask(hn, B), n.flatMapIOEither = (0, i.dual)(2, function(W, K) {
      return (0, n.flatMap)(W, (0, n.fromIOEitherK)(K));
    }), n.flatMapTaskOption = (0, i.dual)(3, function(W, K, w) {
      return (0, n.flatMap)(W, function(V) {
        return (0, n.fromTaskOption)(function() {
          return w(V);
        })(K(V));
      });
    }), n.chainEitherK = n.flatMapEither, n.chainEitherKW = n.flatMapEither, n.chainFirstEitherK = n.tapEither, n.chainFirstEitherKW = n.tapEither, n.fromPredicate = (0, b.fromPredicate)(n.FromEither), n.filterOrElse = (0, b.filterOrElse)(n.FromEither, n.Chain), n.filterOrElseW = n.filterOrElse, n.fromEitherK = (0, b.fromEitherK)(n.FromEither), n.fromIOK = (0, N.fromIOK)(n.FromIO), n.chainIOK = n.flatMapIO, n.chainFirstIOK = n.tapIO, n.fromTaskK = (0, S.fromTaskK)(n.FromTask), n.chainTaskK = n.flatMapTask, n.chainFirstTaskK = n.tapTask, n.chainIOEitherKW = n.flatMapIOEither, n.chainIOEitherK = n.flatMapIOEither;
    function Tn(W) {
      return function() {
        var K = Array.prototype.slice.call(arguments);
        return function() {
          return new Promise(function(w) {
            var V = function(Y, z) {
              return Y != null ? w(e.left(Y)) : w(e.right(z));
            };
            W.apply(null, K.concat(V));
          });
        };
      };
    }
    var wn = function(W, K, w) {
      return (0, n.bracketW)(W, K, w);
    };
    n.bracket = wn;
    var Nn = function(W, K, w) {
      return (0, n.flatMap)(W, function(V) {
        return a.flatMap(K(V), function(Y) {
          return (0, n.flatMap)(w(V, Y), function() {
            return a.of(Y);
          });
        });
      });
    };
    n.bracketW = Nn, n.Do = (0, n.of)(e.emptyRecord), n.bindTo = (0, E.bindTo)(n.Functor);
    var Pn = /* @__PURE__ */ (0, E.let)(n.Functor);
    n.let = Pn, n.bind = c.bind(n.Chain), n.bindW = n.bind, n.apS = (0, h.apS)(n.ApplyPar), n.apSW = n.apS, n.ApT = (0, n.of)(e.emptyReadonlyArray);
    var $ = function(W) {
      return (0, i.flow)(a.traverseReadonlyNonEmptyArrayWithIndex(W), a.map(t.traverseReadonlyNonEmptyArrayWithIndex(i.SK)));
    };
    n.traverseReadonlyNonEmptyArrayWithIndex = $;
    var nn = function(W) {
      var K = (0, n.traverseReadonlyNonEmptyArrayWithIndex)(W);
      return function(w) {
        return e.isNonEmpty(w) ? K(w) : n.ApT;
      };
    };
    n.traverseReadonlyArrayWithIndex = nn;
    var yn = function(W) {
      return function(K) {
        return function() {
          return e.tail(K).reduce(function(w, V, Y) {
            return w.then(function(z) {
              return e.isLeft(z) ? w : W(Y + 1, V)().then(function(an) {
                return e.isLeft(an) ? an : (z.right.push(an.right), z);
              });
            });
          }, W(0, e.head(K))().then(t.map(e.singleton)));
        };
      };
    };
    n.traverseReadonlyNonEmptyArrayWithIndexSeq = yn;
    var Bn = function(W) {
      var K = (0, n.traverseReadonlyNonEmptyArrayWithIndexSeq)(W);
      return function(w) {
        return e.isNonEmpty(w) ? K(w) : n.ApT;
      };
    };
    n.traverseReadonlyArrayWithIndexSeq = Bn, n.traverseArrayWithIndex = n.traverseReadonlyArrayWithIndex;
    var zn = function(W) {
      return (0, n.traverseReadonlyArrayWithIndex)(function(K, w) {
        return W(w);
      });
    };
    n.traverseArray = zn, n.sequenceArray = /* @__PURE__ */ (0, n.traverseArray)(i.identity), n.traverseSeqArrayWithIndex = n.traverseReadonlyArrayWithIndexSeq;
    var Jn = function(W) {
      return (0, n.traverseReadonlyArrayWithIndexSeq)(function(K, w) {
        return W(w);
      });
    };
    n.traverseSeqArray = Jn, n.sequenceSeqArray = /* @__PURE__ */ (0, n.traverseSeqArray)(i.identity), n.chain = n.flatMap, n.chainW = n.flatMap, n.chainFirst = n.tap, n.chainFirstW = n.tap, n.orElseFirst = n.tapError, n.orElseFirstW = n.tapError, n.taskEither = {
      URI: n.URI,
      bimap: n.mapBoth,
      mapLeft: n.mapError,
      map: Q,
      of: n.of,
      ap: en,
      chain: n.flatMap,
      alt: k,
      fromIO: n.fromIO,
      fromTask: n.fromTask,
      throwError: n.throwError
    }, n.taskEitherSeq = {
      URI: n.URI,
      bimap: n.mapBoth,
      mapLeft: n.mapError,
      map: Q,
      of: n.of,
      ap: L,
      chain: n.flatMap,
      alt: k,
      fromIO: n.fromIO,
      fromTask: n.fromTask,
      throwError: n.throwError
    }, n.getApplySemigroup = /* @__PURE__ */ (0, h.getApplySemigroup)(n.ApplySeq), n.getApplyMonoid = /* @__PURE__ */ (0, g.getApplicativeMonoid)(n.ApplicativeSeq);
    var Kn = function(W) {
      return (0, h.getApplySemigroup)(a.ApplySeq)(t.getSemigroup(W));
    };
    n.getSemigroup = Kn;
    function Cn(W) {
      var K = H(a.ApplicativePar, W), w = rn(W);
      return {
        URI: n.URI,
        _E: void 0,
        map: Q,
        ap: K.ap,
        of: n.of,
        chain: n.flatMap,
        bimap: n.mapBoth,
        mapLeft: n.mapError,
        alt: w.alt,
        fromIO: n.fromIO,
        fromTask: n.fromTask,
        throwError: n.throwError
      };
    }
  })(mn)), mn;
}
var Nr = /* @__PURE__ */ oa();
const Pr = async (n, A, R, M, O, f) => {
  let g = R, h = M, c = O;
  const u = {}, t = await n.runCode(A, [
    ...Lr({
      hoppFetchHook: f
    }),
    Yr(
      {
        envs: Sn.cloneDeep(R),
        request: Sn.cloneDeep(M),
        cookies: O ? Sn.cloneDeep(O) : null,
        handleSandboxResults: ({ envs: r, request: v, cookies: b }) => {
          g = r, h = v, c = b;
        }
      },
      u
    )
  ]);
  if (t.type === "error") {
    const r = u.bootstrapError !== void 0, v = r ? u.bootstrapError : t.err;
    if (r || jr(v))
      return Dr(), "retry";
    if (t.err !== null && typeof t.err == "object" && "message" in t.err) {
      const b = "name" in t.err && typeof t.err.name == "string" ? t.err.name : "", N = b ? `${b}: ` : "";
      return En(`Script execution failed: ${N}${t.err.message}`);
    }
    return En(`Script execution failed: ${String(t.err)}`);
  }
  if (u.scriptExecutionError) {
    const { name: r, message: v } = u.scriptExecutionError, b = r ? `${r}: ` : "";
    return En(`Script execution failed: ${b}${v}`);
  }
  return u.capture && u.capture(), Br({
    updatedEnvs: g,
    updatedRequest: h,
    updatedCookies: c
  });
}, va = (n, A, R, M, O) => () => (async () => {
  try {
    const f = await Yn(), g = await Pr(
      f,
      n,
      A,
      R,
      M,
      O
    );
    if (g !== "retry")
      return g;
    const h = await Yn(), c = await Pr(
      h,
      n,
      A,
      R,
      M,
      O
    );
    return c === "retry" ? En(
      "Script execution failed: sandbox initialization error (persistent)"
    ) : c;
  } catch (f) {
    const g = f instanceof Error && f.name ? `${f.name}: ` : "", h = f instanceof Error ? f.message : String(f);
    return En(`Script execution failed: ${g}${h}`);
  }
})(), wa = (n, A) => {
  const { envs: R, experimentalScriptingSandbox: M = !0 } = A;
  if (M) {
    const { request: O, cookies: f, hoppFetchHook: g } = A;
    return va(
      n,
      R,
      O,
      f,
      g
    );
  }
  return Gn(
    Nr.tryCatch(
      async () => {
        const { runPreRequestScriptWithIsolatedVm: O } = await import("./legacy-BcCkR3_K.js");
        return O(n, R);
      },
      (O) => `Legacy sandbox execution failed: ${O}`
    ),
    Nr.chain((O) => O)
  );
};
function da(n) {
  return Gr(En, n.of);
}
function ha(n) {
  return function(A, R) {
    return n.chain(A, function(M) {
      return kr(M) ? n.of(M) : R(M.right);
    });
  };
}
var ma = function(n, A) {
  return Gn(n, ya(A));
}, ga = function(n, A) {
  return Gn(n, Ia(A));
}, ya = function(n) {
  return function(A) {
    return function() {
      return Promise.resolve().then(A).then(n);
    };
  };
}, Ia = function(n) {
  return function(A) {
    return function() {
      return Promise.all([Promise.resolve().then(A), Promise.resolve().then(n)]).then(function(R) {
        var M = R[0], O = R[1];
        return M(O);
      });
    };
  };
}, ur = function(n) {
  return function() {
    return Promise.resolve(n);
  };
}, Oa = /* @__PURE__ */ Vr(2, function(n, A) {
  return function() {
    return Promise.resolve().then(n).then(function(R) {
      return A(R)();
    });
  };
}), Ea = "Task", _a = {
  of: ur
}, ba = {
  URI: Ea,
  map: ma,
  of: ur,
  ap: ga,
  chain: Oa
}, Ra = function(n, A, R, M) {
  function O(f) {
    return f instanceof R ? f : new R(function(g) {
      g(f);
    });
  }
  return new (R || (R = Promise))(function(f, g) {
    function h(t) {
      try {
        u(M.next(t));
      } catch (r) {
        g(r);
      }
    }
    function c(t) {
      try {
        u(M.throw(t));
      } catch (r) {
        g(r);
      }
    }
    function u(t) {
      t.done ? f(t.value) : O(t.value).then(h, c);
    }
    u((M = M.apply(n, A || [])).next());
  });
}, Ma = function(n, A) {
  var R = { label: 0, sent: function() {
    if (f[0] & 1) throw f[1];
    return f[1];
  }, trys: [], ops: [] }, M, O, f, g;
  return g = { next: h(0), throw: h(1), return: h(2) }, typeof Symbol == "function" && (g[Symbol.iterator] = function() {
    return this;
  }), g;
  function h(u) {
    return function(t) {
      return c([u, t]);
    };
  }
  function c(u) {
    if (M) throw new TypeError("Generator is already executing.");
    for (; g && (g = 0, u[0] && (R = 0)), R; ) try {
      if (M = 1, O && (f = u[0] & 2 ? O.return : u[0] ? O.throw || ((f = O.return) && f.call(O), 0) : O.next) && !(f = f.call(O, u[1])).done) return f;
      switch (O = 0, f && (u = [u[0] & 2, f.value]), u[0]) {
        case 0:
        case 1:
          f = u;
          break;
        case 4:
          return R.label++, { value: u[1], done: !1 };
        case 5:
          R.label++, O = u[1], u = [0];
          continue;
        case 7:
          u = R.ops.pop(), R.trys.pop();
          continue;
        default:
          if (f = R.trys, !(f = f.length > 0 && f[f.length - 1]) && (u[0] === 6 || u[0] === 2)) {
            R = 0;
            continue;
          }
          if (u[0] === 3 && (!f || u[1] > f[0] && u[1] < f[3])) {
            R.label = u[1];
            break;
          }
          if (u[0] === 6 && R.label < f[1]) {
            R.label = f[1], f = u;
            break;
          }
          if (f && R.label < f[2]) {
            R.label = f[2], R.ops.push(u);
            break;
          }
          f[2] && R.ops.pop(), R.trys.pop();
          continue;
      }
      u = A.call(n, R);
    } catch (t) {
      u = [6, t], O = 0;
    } finally {
      M = f = 0;
    }
    if (u[0] & 5) throw u[1];
    return { value: u[0] ? u[1] : void 0, done: !0 };
  }
}, Kr = /* @__PURE__ */ da(_a), Aa = ur, Sa = function(n, A) {
  return function() {
    return Ra(void 0, void 0, void 0, function() {
      var R;
      return Ma(this, function(M) {
        switch (M.label) {
          case 0:
            return M.trys.push([0, 2, , 3]), [4, n().then(sr)];
          case 1:
            return [2, M.sent()];
          case 2:
            return R = M.sent(), [2, pr(A(R))];
          case 3:
            return [
              2
              /*return*/
            ];
        }
      });
    });
  };
}, qa = /* @__PURE__ */ Vr(2, ha(ba)), Fa = {
  fromEither: Aa
};
Fa.fromEither;
var Ua = qa;
const Cr = async (n, A, R, M, O, f) => {
  const g = [
    { descriptor: "root", expectResults: [], children: [] }
  ];
  let h = R, c = g;
  const u = [], t = {}, r = await n.runCode(A, [
    ...Lr({
      hoppFetchHook: f
    }),
    xr(
      {
        envs: Sn.cloneDeep(R),
        testRunStack: Sn.cloneDeep(g),
        request: Sn.cloneDeep(M),
        response: Sn.cloneDeep(O),
        // TODO: Post type update, accommodate for cookies although platform support is limited
        cookies: null,
        handleSandboxResults: ({ envs: S, testRunStack: i }) => {
          h = S, c = i;
        },
        onTestPromise: (S) => {
          u.push(S);
        }
      },
      t
    )
  ]);
  if (r.type === "error") {
    const S = t.bootstrapError !== void 0, i = S ? t.bootstrapError : r.err;
    if (S || jr(i))
      return Dr(), "retry";
    if (r.err !== null && typeof r.err == "object" && "message" in r.err) {
      const E = "name" in r.err && typeof r.err.name == "string" ? r.err.name : "", e = E ? `${E}: ` : "";
      return En(`Script execution failed: ${e}${r.err.message}`);
    }
    return En(`Script execution failed: ${String(r.err)}`);
  }
  if (u.length > 0)
    for (let S = 0; S < u.length; S++)
      await u[S];
  if (t.scriptExecutionError) {
    const { name: S, message: i } = t.scriptExecutionError, E = S ? `${S}: ` : "";
    return En(`Script execution failed: ${E}${i}`);
  }
  t.capture && t.capture();
  const v = c.flatMap((S) => S.children).flatMap((S) => S.expectResults || []).filter(
    (S) => S.status === "error" && /^(ReferenceError|TypeError|SyntaxError|RangeError|URIError|EvalError|AggregateError|InternalError|Error):/.test(
      S.message
    )
  );
  if (v.length > 0)
    return En(`Script execution failed: ${v[0].message}`);
  const b = Sn.cloneDeep(c), N = Sn.cloneDeep(h);
  return Br({
    tests: b,
    envs: N
  });
}, Wa = (n, A, R, M, O) => () => (async () => {
  try {
    const f = await Yn(), g = await Cr(
      f,
      n,
      A,
      R,
      M,
      O
    );
    if (g !== "retry")
      return g;
    const h = await Yn(), c = await Cr(
      h,
      n,
      A,
      R,
      M,
      O
    );
    return c === "retry" ? En(
      "Script execution failed: sandbox initialization error (persistent)"
    ) : c;
  } catch (f) {
    const g = f instanceof Error && f.name ? `${f.name}: ` : "", h = f instanceof Error ? f.message : String(f);
    return En(`Script execution failed: ${g}${h}`);
  }
})(), Na = (n, A) => {
  try {
    const g = Object.getPrototypeOf(
      async function() {
      }
    ).constructor;
    new g(n);
  } catch (g) {
    const h = g, c = `${"name" in h ? h.name : "SyntaxError"}: ${h.message}`;
    return Kr(`Script execution failed: ${c}`);
  }
  const R = $r(A.response);
  if (kr(R))
    return Kr(`Response marshalling failed: ${R.left}`);
  const M = R.right, { envs: O, experimentalScriptingSandbox: f = !0 } = A;
  if (f) {
    const { request: g, hoppFetchHook: h } = A;
    return Wa(
      n,
      O,
      g,
      M,
      h
    );
  }
  return Gn(
    Sa(
      async () => {
        const { runPostRequestScriptWithIsolatedVm: g } = await import("./legacy-CLm0ue_S.js");
        return g(
          n,
          O,
          M
        );
      },
      (g) => `Legacy sandbox execution failed: ${g}`
    ),
    Ua((g) => g)
  );
};
export {
  Nr as T,
  Na as a,
  Ua as c,
  wa as r,
  Sa as t
};
